<template>
<div class="container">
  <div style="background: #f5f5f5;height: 100vh; overflow:auto" class="projector-condition1 " v-if="!isSimple || showConditionFlag">
    <!-- 导航栏 -->
    <Header :title="$t('T_MORE_SETTINGS')" link="projectorView" @back="backAction"></Header>
    <div class="appContent">
      <!-- room size -->
      <div class="panel-box">
        <div class="panel-box-title-big">{{$t('T_BASIC_SETTINGS')}}</div>
        <div class="panel-box-title">{{$t('T_ROOM_SIZE')}}</div>
        <van-row gutter="20" class="size">
          <van-col span="8">
            <div class="text-center font-blue">{{$t('T_WIDTH')}}</div>
              <van-field class="toggle-box-item" v-model='roomWData' :disabled="isUSTWall || isSimple"
                @input="testDigital($event, 'roomWData')"
                @blur='changeMutation("roomWData", "SET_GRAPH_ROOMW", true)'
                @keyup.enter.native='changeMutation("roomWData", "SET_GRAPH_ROOMW", "changeRoomW")'>
                <span slot="button" class="field-tip">{{unitLabel}}</span>
              </van-field>
          </van-col>
          <van-col span="8">
            <div class="text-center font-blue">{{$t('T_HEIGHT')}}</div>
            <van-field class="toggle-box-item" v-model='roomHData'
              @input="testDigital($event, 'roomHData')"
              @blur='changeMutation("roomHData", "SET_GRAPH_ROOMH", true)'
              @keyup.enter.native='changeMutation("roomHData", "SET_GRAPH_ROOMH", "changeRoomH")'>
              <span slot="button" class="field-tip">{{unitLabel}}</span>
            </van-field>
          </van-col>
          <van-col span="8">
            <div class="text-center font-blue">{{$t('T_DEPTH')}}</div>
            <van-field class="toggle-box-item" v-model='roomDData' :disabled="isUSTWall || isSimple"
              @input="testDigital($event, 'roomDData')"
              @blur='changeMutation("roomDData", "SET_GRAPH_ROOMD", true)'
              @keyup.enter.native='changeMutation("roomDData", "SET_GRAPH_ROOMD", true)'>
              <span slot="button" class="field-tip">{{unitLabel}}</span>
            </van-field>
          </van-col>
        </van-row>
        <!-- Position -->
        <div class="panel-box-title">{{$t('T_POSITION')}}</div>
        <van-row v-if="!(isLShaped && isSimple)" gutter="20" class="col7">
          <van-col span="8"  v-if="selectedModelData.name.indexOf('ELPMB87') > -1">
            <div class="toggle-box-item disable"
              :style="{'line-height':(language === 'et' || language === 'el' || language === 'hr' || language === 'pt-PT' ? 'normal' : '31px')}"
              :class="{'checked-box-item': position == 0}">
              {{$t('T_POS_DESKTOP')}}</div>
          </van-col>
          <van-col span="8" v-else>
            <div class="toggle-box-item"
              :style="{'line-height':(language === 'et' || language === 'el' || language === 'hr' || language === 'pt-PT' ? 'normal' : '31px')}"
              :class="{'checked-box-item': position == 0}" @click="changePosition('position', 0)">
              {{$t('T_POS_DESKTOP')}}</div>
          </van-col>
          <!-- positionCeiling为false || モデルで「ELPMB87」が含まれる  天吊りdisable -->
          <van-col span="8" v-if="!selectedModelData.positionCeiling || selectedModelData.name.indexOf('ELPMB87') > -1">
            <div class="toggle-box-item disable" :style="{'line-height':(language === 'et' ? 'normal' : '31px')}"
              :class="{'checked-box-item': position == 1}">
              {{$t('T_POS_CEILING')}}</div>
          </van-col>
          <van-col span="8" v-else>
            <div class="toggle-box-item" :style="{'line-height':(language === 'et' ? 'normal' : '31px')}"
              :class="{'checked-box-item': position == 1}" @click="changePosition('position', 1)">
              {{$t('T_POS_CEILING')}}</div>
          </van-col>
          <van-col span="8" v-if="!selectedModelData.positionWall">
            <div class="toggle-box-item disable" :style="{'line-height':(language === 'et' ? 'normal' : '31px')}"
              :class="{'checked-box-item': position == 2}">{{$t('T_POS_WALL')}}</div>
          </van-col>
          <van-col span="8" v-else>
            <div class="toggle-box-item " :style="{'line-height':(language === 'et' ? 'normal' : '31px')}"
              :class="{'checked-box-item': position == 2}" @click="changePosition('position', 2)">{{$t('T_POS_WALL')}}
            </div>
          </van-col>
        </van-row>
        <van-row v-if="isLShaped" gutter="20" class="col7">
          <van-col span="12">
            <div class="toggle-box-item " :style="{'line-height':(['de', 'fr', 'it', 'es', 'pt-PT', 'ru', 'cs', 'pl', 'bg', 'et', 'lv', 'el', 'hr', 'vi'].includes(language) ? 'normal' :'31px')}"
              :class="{'checked-box-item': position == 3}" @click="changePosition('position', 3)">{{$t('T_POS_WALL_LENS_UP')}}
            </div>
          </van-col>
          <van-col span="12">
            <div class="toggle-box-item " :style="{'line-height': (['de', 'fr', 'it', 'es', 'pt-PT', 'ru', 'cs', 'pl', 'bg', 'et', 'lv', 'el', 'hr', 'vi'].includes(language) ? 'normal' :'31px')}"
              :class="{'checked-box-item': position == 4}" @click="changePosition('position', 4)">{{$t('T_POS_WALL_LENS_DOWN')}}
            </div>
          </van-col>
        </van-row>
        <!-- 床からフットまで -->
        <template v-if="!(isLShaped && isSimple)">
          <div class="panel-check clearfix ">
            <!-- <div class="panel-box-title-big ">{{$t('T_SCREEN_POSITION')}}</div> -->
            <div class="panel-box-title-big2"> {{$t('T_RESULT_FLOOR_TO_FOOT_OF_PROJECTOR_HEIGHT_NO_COLON')}}</div>
            <van-checkbox v-if="!isUSTWall && !isSimple" v-model="floor_footProjector_checked" shape="square" checked-color="#10218b"></van-checkbox>
            <van-icon v-if="!isUSTWall && !isSimple" name="lock" />
          </div>
          <van-row gutter="20">
            <van-col span="24">
              <van-field class="toggle-box-item" v-model='floor2footProjectorData'
                @blur='changeFloor2footProjector()'
                @input="testDigital($event, 'floor2footProjectorData')"
                @keyup.enter.native='changeFloor2footProjector()'
                :disabled="position !== 0 || floor_footProjector_checked"
                >
                <span slot="button" class="field-tip">{{unitLabel}}</span>
              </van-field>
            </van-col>
          </van-row>
        </template>
        <!-- 床からプロジェクター背面まで -->
        <template v-else-if="position == 3">
          <div class="panel-check clearfix ">
            <div class="panel-box-title-big2"> {{$t('T_FLOOR_TO_REAR_OF_PROJECTOR')}}</div>
          </div>
          <van-row gutter="20">
            <van-col span="24">
              <van-field class="toggle-box-item" v-model='floor2rearProjectorData'
                @blur='changeFloor2rearProjector()'
                @input="testDigital($event, 'floor2rearProjectorData')"
                @keyup.enter.native='changeFloor2rearProjector()'
                >
                <span slot="button" class="field-tip">{{unitLabel}}</span>
              </van-field>
            </van-col>
          </van-row>
        </template>
        <!-- 床からプロジェクター前面まで -->
        <template v-else-if="position == 4">
          <div class="panel-check clearfix ">
            <div class="panel-box-title-big2"> {{$t('T_FLOOR_TO_FRONT_OF_PROJECTOR')}}</div>
          </div>
          <van-row gutter="20">
            <van-col span="24">
              <van-field class="toggle-box-item" v-model='floor2frontProjectorData'
                @blur='changeFloor2frontProjector()'
                @input="testDigital($event, 'floor2frontProjectorData')"
                @keyup.enter.native='changeFloor2frontProjector()'
                >
                <span slot="button" class="field-tip">{{unitLabel}}</span>
              </van-field>
            </van-col>
          </van-row>
        </template>
        <!-- 天井から天吊り金具取付部まで -->
        <template v-if="!isSimple">
          <div class="panel-check clearfix ">
            <div class="panel-box-title-big2 panel-box-title-width"> {{$t('T_RESULT_CEILING_TO_BOTTOM_HEIGHT2')}}</div>
            <van-checkbox v-if="!isUSTWall && !isSimple" v-model="ceiling_bottomProjector_checked" @change="changeCeiling2bottomProjectorChecked()" shape="square" checked-color="#10218b"></van-checkbox>
            <van-icon v-if="!isUSTWall && !isSimple" name="lock" />
          </div>
          <van-row gutter="20">
            <van-col span="24">
              <van-field class="toggle-box-item" v-model='ceiling2bottomProjectorData'
                @blur='changeCeiling2bottomProjector()'
                @input="testDigital($event, 'ceiling2bottomProjectorData')"
                @keyup.enter.native='changeCeiling2bottomProjector()'
                :disabled="position !== 1 || ceiling_bottomProjector_checked"
                >
                <span slot="button" class="field-tip">{{unitLabel}}</span>
              </van-field>
            </van-col>
          </van-row>
        </template>
        <!-- 壁から壁掛け金具取付部まで -->
        <template v-if="!isSimple && isLShaped">
          <div class="panel-check clearfix ">
            <div class="panel-box-title-big2 panel-box-title-width"> {{$t('T_WALL_TO_WALL_MOUNT_BRACKET_ATTACHMAENT_POINT')}}</div>
            <van-checkbox v-if="!isUSTWall && !isSimple" v-model="wall_wallProjector_checked" @change="changeWall2WallProjectorChecked()" shape="square" checked-color="#10218b"></van-checkbox>
            <van-icon v-if="!isUSTWall && !isSimple" name="lock" />
          </div>
          <van-row gutter="20">
            <van-col span="24">
              <van-field class="toggle-box-item" v-model='wall2WallProjectorData'
                @blur='changeWall2WallProjector()'
                @input="testDigital($event, 'wall2WallProjectorData')"
                @keyup.enter.native='changeWall2WallProjector()'
                :disabled="(position !== 3 && position !== 4) || wall_wallProjector_checked"
                >
                <span slot="button" class="field-tip">{{unitLabel}}</span>
              </van-field>
            </van-col>
          </van-row>
        </template>
        <!-- Finger touch -->
        <div class="panel-box-title">{{$t('T_FINGER_TOUCH')}}</div>
        <van-row gutter="20" class="col7">
          <van-col span="8">
            <div class="toggle-box-item" :class="{'checked-box-item':fingerTouchStatus,'disable': !isUSTWall}"
              @click="changeFingerTouchStatus(true)">{{$t('T_ON')}}</div>
          </van-col>
          <van-col span="8">
            <div class="toggle-box-item" :class="{'checked-box-item':!fingerTouchStatus,'disable': !isUSTWall}"
              @click="changeFingerTouchStatus(false)">{{$t('T_OFF')}}</div>
          </van-col>
        </van-row>
        <!-- Scale -->
        <div class="panel-box-title">{{$t('T_SCALE')}}</div>
        <van-row gutter="20">
          <van-col span="24">
            <dropdown v-model="unitData" :selectData="unitDataOptions" :label="'label'"></dropdown>
          </van-col>
        </van-row>
      </div>
      <!-- screen size -->
      <div class="panel-box" v-if="!isSimple">
        <div class="panel-check clearfix">
          <div class="panel-box-title-big ">{{$t('T_SCREEN_SIZE')}}</div>
          <van-checkbox v-if="!isUSTWall" v-model="screen_size_checked" shape="square" checked-color="#10218b"></van-checkbox>
          <van-icon v-if="!isUSTWall" name="lock" />
        </div>
        <div class="panel-box-title">{{$t('T_ASPECT_RATIO')}}</div>
        <van-row gutter="20">
          <van-col span="24">
            <dropdown v-model="aspectRatioData" :selectData="selectedLensOptions" @change="changeAspectRatio" :disabled="screen_size_checked"></dropdown>
          </van-col>
        </van-row>
        <dropdown v-model="dwhSelect" :selectData="dwhSelectOptions" :label="'label'" @change="changeDwhSelect" :disabled="screen_size_checked"></dropdown>
        <van-row gutter="20" class="size margin_bottom">
          <van-col span="24" v-if="dwhSelect==='1'">
            <van-field class="toggle-box-item" v-model='scrnWData'
              @input="testDigital($event, 'scrnWData')"
              @blur='changeMutation("scrnWData", "SET_GRAPH_SCRNW", "changeScreenW")'
              @keyup.enter.native='changeMutation("scrnWData", "SET_GRAPH_SCRNW", "changeScreenW")'
              :disabled="screen_size_checked">
              <span slot="button" class="field-tip">{{unitLabel}}</span>
            </van-field>
          </van-col>
          <van-col span="24" v-if="dwhSelect==='2'">
            <van-field class="toggle-box-item" v-model='scrnHData'
              @input="testDigital($event, 'scrnHData')"
              @blur='changeMutation("scrnHData", "SET_GRAPH_SCRNH", "changeScreenH")'
              @keyup.enter.native='changeMutation("scrnHData", "SET_GRAPH_SCRNH", "changeScreenH")'
              :disabled="screen_size_checked">
              <span slot="button" class="field-tip">{{unitLabel}}</span>
            </van-field>
          </van-col>
          <van-col span="24" v-if="dwhSelect==='0'">
            <van-field class="toggle-box-item"
              v-model='screenSizeData'
              @input="testDigital($event, 'screenSizeData')"
              @blur='changeScreenSize'
              @keyup.enter.native='changeScreenSize'
              :disabled="screen_size_checked">
              <span slot="button" class="field-tip">inch</span>
            </van-field>
          </van-col>
        </van-row>
        <!-- <div class='screen_size_aspect'>
          <van-field class="toggle-box-item" :class="{'screen_size_out_of_spec': outOfSpec}"
              v-model='dwhDataDetailData'
              @change="changeDwhData"
              @input="testDigital($event, 'dwhDataDetailData')"
              :disabled="screen_size_checked">
              <span class="field-tip" slot="button" v-if="dwhSelect==='0'">inch</span>
              <span class="field-tip" slot="button" v-if="dwhSelect!=='0'">{{unitLabel}}</span>
            </van-field>
        </div> -->
      <!-- <div class="sld screen_size_sld"> -->
        <div class="out_of_spec_warning" v-if="isOutOfSpec">
          <img src='../../src/assets/parts/icon/TDC_warning.png'/>
          <span>{{$t('T_OUT_OF_SPEC_MODE')}}</span>
        </div>
        <!-- screen-size的slider滑块 advance-->
         <div class="screen-size_sliderbar" v-if="!isOutOfSpec">
          <div class="throw_dis_sld" v-show="real_throw_distance_checked">
            <div class="border" ref="throwDisLine"></div>
            <el-slider ref='realThrowDisSliderRangeFlag' v-model="realThrowDisSliderRangeData" :step="0.001" :show-tooltip="false"
              class="throw_distance_slider pjy-slider" :min="0" :max="realThrowDisSliderRangeMax"
              ></el-slider>
            <label class="lab" ref = "distanceLockedSizetFormat" style="position: absolute;top: -5px;">{{distanceLockedSizetFormat}}</label>
            <label class="lab" ref = "distanceLockedSizewFormat" style="position: absolute;top: 27px;">{{distanceLockedSizewFormat}}</label>
          </div>
          <div class="screen_size_sld" v-show="!real_throw_distance_checked">
            <el-slider ref = 'screenSizeSliderFlag' v-showTip v-model="screenSizeSlider" :disabled="screen_size_checked" :step="0.001" :show-tooltip="false" class="throw_distance_slider" @change="screenChanged"  :min="ratioScreenSizeMin" :max="ratioScreenSizeMax"></el-slider>
          </div>
          <label class="lab" style="margin-bottom: 10px;display: inline-block;">{{diagonalMinFormat}}</label>
          <label class="lab" style="float:right;margin-bottom: 10px;display: inline-block;">{{diagonalMaxFormat}}</label>
        </div>
      </div>
      <div class="panel-box screen-position">
        <div class="panel-check clearfix ">
          <div class="panel-box-title-big ">{{$t('T_SCREEN_POSITION')}}</div>
          <van-checkbox v-if="!isUSTWall && !isSimple" v-model="throw_distance_checked" shape="square" checked-color="#10218b"></van-checkbox>
          <van-icon v-if="!isUSTWall && !isSimple" name="lock" />
        </div>
        <div v-if="isLShaped01">
          <div class="panel-box-title mt0">{{$t('T_LEFT_WALL_TO_TOP_OF_SCREEN')}}</div>
          <van-row gutter="20">
            <van-col span="24">
              <van-field class="toggle-box-item" v-model='leftWall2topData'
                @blur='changeLeftWall2top()'
                @input="testDigital($event, 'leftWall2topData')"
                @keyup.enter.native='changeLeftWall2top()'
                :disabled="throw_distance_checked">
                <span slot="button" class="field-tip">{{unitLabel}}</span>
              </van-field>
            </van-col>
          </van-row>
        </div>
        <div v-else>
          <div class="panel-box-title mt0">{{$t('T_FLOOR_TO_BOTTOM')}}</div>
          <van-row gutter="20">
            <van-col span="24">
              <van-field class="toggle-box-item" v-model='floor2bottomData'
                @blur='changeFloorMutation()'
                @input="testDigital($event, 'floor2bottomData')"
                @keyup.enter.native='changeFloorMutation()'
                :disabled="throw_distance_checked">
                <span slot="button" class="field-tip">{{unitLabel}}</span>
              </van-field>
            </van-col>
          </van-row>
        </div>
        <!--ボードの厚み -->
        <div v-if="isUSTWall"  class="panel-box-title">{{$t('T_THICKNESS_BOARD')}}
          <span>(0 ~ {{ustOffsetMax}} {{unitLabel}})</span></div>
        <div v-else class="panel-box-title">{{$t('T_SCREEN_OFFSET')}}
        </div>
        <van-row gutter="20">
          <van-col span="24">
            <van-field class="toggle-box-item" v-model='offsetData'
              @blur='changeMutation("offsetData", "SET_OFFSET")'
              @input="testDigital($event, 'offsetData')"
              @keyup.enter.native='changeMutation("offsetData", "SET_OFFSET")'
              :disabled="throw_distance_checked">
              <span slot="button" class="field-tip">{{unitLabel}}</span>
            </van-field>
          </van-col>
        </van-row>
      </div>
      <!-- Throw Distance -->
      <div class="panel-box" v-if="!isSimple">
        <div class="panel-check clearfix ">
          <!-- <div class="panel-box-title-big ">{{$t('T_SCREEN_POSITION')}}</div> -->
          <div class="panel-box-title-big">{{$t('T_THROW_DISTANCE')}}</div>
          <van-checkbox v-if="!isUSTWall" v-model="real_throw_distance_checked" shape="square" checked-color="#10218b"></van-checkbox>
          <!-- <van-checkbox v-model="real_throw_distance_checked" shape="square" checked-color="#10218b"></van-checkbox> -->
          <van-icon v-if="!isUSTWall" name="lock" />
        </div>
        <div class="panel-box-title" v-if="!isUSTWall">{{$t('T_SCREEN_TO_LENS')}}</div>
        <div class="panel-box-title" v-else>{{$t('T_WALL_TO_PJ_DISTANCE')}}</div>
        <van-row gutter="20">
          <van-col span="24">
            <van-field class="toggle-box-item" v-model='pjYData'
              @input="testDigital($event, 'pjYData')"
              :disabled="screen2LensFlag"
              @blur='changeMutation("pjYData", "SET_GRAPH_PJY", "changeDistance")'
              @keyup.enter.native='changeMutation("pjYData", "SET_GRAPH_PJY", "changeDistance")'>
              <span slot="button" class="field-tip">{{unitLabel}}</span>
            </van-field>
          </van-col>
        </van-row>
        <!-- Throw distance的slider滑块 advance-->
     <div class="condition_sliderbar" v-if="!isOutOfSpec">
        <div class="sld throw_dis_sld">
          <div class="border" ref="throwDisLine"></div>
          <label class="lab" v-if="!real_throw_distance_checked" :style="{left: sliderL - 5 + '%'}" style="position: absolute;top: 5px;">{{throwDisSliderwFormat}}</label>
          <label class="lab" v-if="!real_throw_distance_checked" :style="{left: slidertL - 5 + '%'}" style="position: absolute;top: 33px;">{{throwDisSlidertFormat}}</label>
           <el-slider ref='throwDisSliderRangeFlag' v-model="throwDisSliderRangeData" @change="throwDisChangedSizeLocked" :show-tooltip="false" :step="0.001" :disabled="!screen_size_checked || real_throw_distance_checked"
            class="throw_distance_slider pjy-slider" :min="0" :max="throwDisSli"
            :style="{left: sliderL + '%'}" :class="screen_size_checked ? 'block':'none'"></el-slider>
          <label class="lab" style="float:left">{{throwDisSliderMinFormat}}</label>
          <label class="lab" style="float:right">{{throwDisSliderMaxFormat}}</label>
        </div>
        <div class="sld throw_dis_sld check">
          <el-slider v-model="throwDisSliderData" v-showTipDis ref="throwDisSliderFlag" @change="throwDisChanged" :disabled="screen_size_checked || real_throw_distance_checked" :show-tooltip="false" class="throw_distance_slider pjy-slider-T" :step="0.001" :min="throwDisSliderMin" :max="throwDisSliderMax" :class="screen_size_checked ? 'none':'block'"></el-slider>
        </div>
        </div>
      </div>
      <div class="panel-box advanced-settings">
        <div class="panel-box-title-big mb0">{{$t('T_ADVANCED_SETTINGS')}}</div>
      </div>
      <van-collapse v-model="activeNames" class="advanced-settings">
        <!-- Ambient condition -->
        <van-collapse-item :title="$t('T_AMBIENT_CONDITION')" title-class="advanced-title" name="1">
          <div class="panel-box-title mt0">{{$t('T_ROOM_TYPE')}}</div>
          <van-row gutter="20">
            <van-col span="24">
              <dropdown v-model="application" :selectData="appSelectData" :label="'label'" @change="changeBrightness">
              </dropdown>
            </van-col>
          </van-row>
          <div class="panel-box-title">{{$t('T_BRIGHTNESS')}}</div>
          <van-row gutter="20">
            <van-col span="24">
              <van-field class="toggle-box-item" v-model='brightnessData'
                @input="testDigital($event, 'brightnessData')" @blur='changBrightnessMutation()' @keyup.enter.native='changBrightnessMutation()'>
                <span slot="button" class="field-tip">lx</span>
              </van-field>
            </van-col>
          </van-row>
          <div class="panel-box-title">{{$t('T_SCREENGAIN')}}</div>
          <van-row gutter="20">
            <van-col span="24">
              <van-field class="toggle-box-item" v-model='gainData' @input="testDigital($event, 'gainData')"
                @blur='changGainMutation()' @keyup.enter.native='changGainMutation()'>
                <span slot="button" class="field-tip">lx</span>
              </van-field>
            </van-col>
          </van-row>
        </van-collapse-item>
        <!-- Projector angle -->
        <van-collapse-item :title="$t('T_PJ_ANGLE')" title-class="advanced-title" name="2" v-if="!isUSTWall && !isSimple">
          <div class="panel-box-title mt0">{{$t('T_PJ_ANGLE_V')}}</div>
          <van-row gutter="20">
            <van-col span="8">
              <van-row gutter="10">
                <van-col span="3">
                  <van-switch v-model='vAngleFlagData' :width='switch_width'
                    @change="changeAngle('vAngleFlagData', 'SET_HANGLEFLAG')" />
                </van-col>
                <van-col span="3">
                  <span class="switch-title">{{vAngleFlagData ? 'ON' : 'OFF'}}</span>
                </van-col>
              </van-row>
            </van-col>
            <van-col span="16">
              <van-field class="toggle-box-item" v-model='vAngleData' :class="{red:isVAngleOut}"
                @input="testDigitalNegative($event, 'vAngleData')" :disabled="!vAngleFlagData"
                @blur='changeAngleData("vAngleData", "SET_VANGLE")'
                @keyup.enter.native='changeAngleData("vAngleData", "SET_VANGLE")'>
                <span slot="button" class="field-tip">°</span>
              </van-field>
            </van-col>
          </van-row>
          <div class="panel-box-title">{{$t('T_PJ_ANGLE_H')}}</div>
          <van-row gutter="20">
            <van-col span="8">
              <van-row gutter="10">
                <van-col span="3">
                  <van-switch v-model='hAngleFlagData' :width='switch_width'
                    @change="changeAngle('hAngleFlagData', 'SET_VANGLEFLAG')" />
                </van-col>
                <van-col span="3">
                  <span class="switch-title">{{hAngleFlagData ? 'ON' : 'OFF'}}</span>
                </van-col>
              </van-row>
            </van-col>
            <van-col span="16">
              <van-field class="toggle-box-item" v-model='hAngleData' :class="{red:isHAngleOut}"
                :disabled="!hAngleFlagData" @input="testDigitalNegative($event, 'hAngleData')"
                @blur='changeAngleData("hAngleData", "SET_HANGLE")'
                @keyup.enter.native='changeAngleData("hAngleData", "SET_HANGLE")'>
                <span slot="button" class="field-tip">°</span>
              </van-field>
            </van-col>
          </van-row>
        </van-collapse-item>
        <!-- Advanced -->
        <!-- <van-collapse-item :title="$t('T_CURVED_WALL')" title-class="advanced-title" name="3">
            <van-row gutter="20">
              <van-col span="12">
                <div>{{$t('T_CURVE_SHAPE')}}</div>
              </van-col>
              <van-col span="12">
                <dropdown></dropdown>
              </van-col>
            </van-row>
            <van-row gutter="20">
              <van-col span="12">
                <div>{{$t('T_CURVE_ANGLE')}}</div>
              </van-col>
              <van-col span="12">
                <dropdown></dropdown>
              </van-col>
            </van-row>
            <van-row gutter="20">
              <van-col span="18">
                <div>{{$t('T_CURVE_DEPTH')}}</div>
              </van-col>
              <van-col span="6">
                <van-field class="toggle-box-item" v-model='depth_input' @input="testDigital($event, 'depth_input')">
                  <span slot="button" class="field-tip">{{unitLabel}}</span>
                </van-field>
              </van-col>
            </van-row>
          </van-collapse-item> -->
      </van-collapse>
      <!-- Out of spec mode   以下勿删 phase2 要用 -->
      <!-- <div class="panel-box out-mode" v-if="!isUSTWall">
        <div class="panel-box-title-big">{{$t('T_OUT_OF_SPEC_MODE')}}</div>
        <van-row style="position: relative" gutter="20">
          <van-col span="5">
            <van-switch v-model='outOfSpec' :width='switch_width' @change="switchchange(outOfSpec)"/>
          </van-col>
          <van-col span="5">
            <span class="switch-label">{{outOfSpec ? 'ON' : 'OFF'}}</span>
          </van-col>
        </van-row>
      </div>
      <van-popup v-model="outOfSpecDialogStatus" class="out_of_spec_dialog" closeable>
        <img src="../../src/assets/parts/icon/TDC_warning.png" alt="">
        <div>
          <p>{{$t('T_OUT_OF_SPEC_MODE_MSG1')}}</p>
          <p>{{$t('T_OUT_OF_SPEC_MODE_MSG2')}}</p>
        </div>
      </van-popup> -->
    </div>
  </div>
  <div class="simple_condition" v-else>
          <!-- screen size -->
      <div class="panel-box" v-if="isSimple">
        <div class="panel-box-title-big ">{{$t('T_SCREEN_SIZE')}}</div>
        <div class="panel-check clearfix" v-if="!isSimple">
          <van-checkbox v-if="!isUSTWall" v-model="screen_size_checked" shape="square" checked-color="#10218b"></van-checkbox>
          <van-icon v-if="!isUSTWall" name="lock" />
        </div>
        <div class="panel-box-title">{{$t('T_ASPECT_RATIO')}}</div>
        <van-row gutter="20">
          <van-col span="24">
            <dropdown v-model="aspectRatioData" :selectData="selectedLensOptions" @change="changeAspectRatio" :disabled="screen_size_checked"></dropdown>
          </van-col>
        </van-row>
        <van-row gutter="20">
          <van-col span="24">
            <dropdown v-model="dwhSelect" :selectData="dwhSelectOptions" :label="'label'" @change="changeDwhSelect" :disabled="screen_size_checked"></dropdown>
          </van-col>
        </van-row>
        <van-row gutter="20" class="size margin_bottom">
          <van-col span="24" v-if="dwhSelect==='1'">
            <van-field class="toggle-box-item" v-model='scrnWData'
              @input="testDigital($event, 'scrnWData')"
              @blur='changeMutation("scrnWData", "SET_GRAPH_SCRNW", "changeScreenW")'
              @keyup.enter.native='changeMutation("scrnWData", "SET_GRAPH_SCRNW", "changeScreenW")'
              :disabled="screen_size_checked">
              <span slot="button" class="field-tip">{{unitLabel}}</span>
            </van-field>
          </van-col>
          <van-col span="24" v-if="dwhSelect==='2'">
            <van-field class="toggle-box-item" v-model='scrnHData'
              @input="testDigital($event, 'scrnHData')"
              @blur='changeMutation("scrnHData", "SET_GRAPH_SCRNH", "changeScreenH")'
              @keyup.enter.native='changeMutation("scrnHData", "SET_GRAPH_SCRNH", "changeScreenH")'
              :disabled="screen_size_checked">
              <span slot="button" class="field-tip">{{unitLabel}}</span>
            </van-field>
          </van-col>
          <van-col span="24" v-if="dwhSelect==='0'">
            <van-field class="toggle-box-item"
              v-model='screenSizeData'
              @input="testDigital($event, 'screenSizeData')"
              @blur='changeScreenSize'
              @keyup.enter.native='changeScreenSize'
              :disabled="screen_size_checked">
              <span slot="button" class="field-tip">inch</span>
            </van-field>
          </van-col>
        </van-row>
        <!-- <div class='screen_size_aspect'>
          <van-field class="toggle-box-item" :class="{'screen_size_out_of_spec': outOfSpec}"
              v-model='dwhDataDetailData'
              @change="changeDwhData"
              @input="testDigital($event, 'dwhDataDetailData')"
              :disabled="screen_size_checked">
              <span class="field-tip" slot="button" v-if="dwhSelect==='0'">inch</span>
              <span class="field-tip" slot="button" v-if="dwhSelect!=='0'">{{unitLabel}}</span>
            </van-field>
        </div> -->
      <!-- <div class="sld screen_size_sld"> -->
        <div class="out_of_spec_warning" v-if="isOutOfSpec">
          <img src='../../src/assets/parts/icon/TDC_warning.png'/>
          <span>{{$t('T_OUT_OF_SPEC_MODE')}}</span>
        </div>
        <!-- screen-size的slider滑块 basic -->
         <div class="screen-size_sliderbar" v-if="!isOutOfSpec">
          <div class="throw_dis_sld" v-show="real_throw_distance_checked">
            <div class="border" ref="throwDisLine"></div>
            <el-slider ref='realThrowDisSliderRangeFlag' v-model="realThrowDisSliderRangeData" :step="0.001" :show-tooltip="false"
              class="throw_distance_slider pjy-slider" :min="0" :max="realThrowDisSliderRangeMax"
              ></el-slider>
            <label class="lab" ref = "distanceLockedSizetFormat" style="position: absolute;top: 5px;">{{distanceLockedSizetFormat}}</label>
            <label class="lab" ref = "distanceLockedSizewFormat" style="position: absolute;top: 5px;">{{distanceLockedSizewFormat}}</label>
          </div>
          <div class="screen_size_sld" v-show="!real_throw_distance_checked">
            <el-slider ref = 'screenSizeSliderFlag' v-showTip v-model="screenSizeSlider" :disabled="screen_size_checked" :step="0.001" :show-tooltip="false" class="throw_distance_slider" @change="screenChanged"  :min="ratioScreenSizeMin" :max="ratioScreenSizeMax"></el-slider>
            <label class="lab"  style="display:inline-block;margin-bottom: 15px;">{{diagonalMinFormat}}</label>
            <label class="lab" style="float:right;display:inline-block;margin-bottom: 15px;">{{diagonalMaxFormat}}</label>
          </div>
        </div>
      </div>
      <div class="space"></div>
            <!-- Throw Distance -->
      <div class="panel-box" v-if="isSimple">
        <div class="panel-box-title-big">{{$t('T_THROW_DISTANCE')}}</div>
        <div class="panel-check clearfix" v-if="!isSimple">
          <!-- <div class="panel-box-title-big ">{{$t('T_SCREEN_POSITION')}}</div> -->
          <van-checkbox v-if="!isUSTWall" v-model="real_throw_distance_checked" shape="square" checked-color="#10218b"></van-checkbox>
          <!-- <van-checkbox v-model="real_throw_distance_checked" shape="square" checked-color="#10218b"></van-checkbox> -->
          <van-icon v-if="!isUSTWall" name="lock" />
        </div>
        <div class="panel-box-title" v-if="!isUSTWall">{{$t('T_SCREEN_TO_LENS')}}</div>
        <div class="panel-box-title" v-else>{{$t('T_WALL_TO_PJ_DISTANCE')}}</div>
        <van-row gutter="20" class="size">
          <van-col span="24">
            <van-field class="toggle-box-item" v-model='pjYData'
              @input="testDigital($event, 'pjYData')"
              :disabled="screen2LensFlag"
              @blur='changeMutation("pjYData", "SET_GRAPH_PJY", "changeDistance")'
              @keyup.enter.native='changeMutation("pjYData", "SET_GRAPH_PJY", "changeDistance")'>
              <span slot="button" class="field-tip">{{unitLabel}}</span>
            </van-field>
          </van-col>
        </van-row>
        <!-- Throw distance的slider滑块 basic-->
     <div class="condition_sliderbar" v-if="!isOutOfSpec">
        <div class="sld throw_dis_sld">
          <div class="border" ref="throwDisLine"></div>
          <label class="lab" :style="{left: sliderL - 5 + '%'}" style="position: absolute;top: 0px;">{{throwDisSliderwFormat}}</label>
          <label class="lab" :style="{left: slidertL - 5 + '%'}" style="position: absolute;top: 33px;">{{throwDisSlidertFormat}}</label>
           <el-slider ref='throwDisSliderRangeFlag' v-model="throwDisSliderRangeData" @change="throwDisChangedSizeLocked" :show-tooltip="false" :step="0.001" :disabled="!screen_size_checked || real_throw_distance_checked"
            class="throw_distance_slider pjy-slider" :min="0" :max="throwDisSli"
            :style="{left: sliderL + '%'}" :class="screen_size_checked ? 'block':'none'"></el-slider>
          <label class="lab" style="float:left">{{throwDisSliderMinFormat}}</label>
          <label class="lab" style="float:right">{{throwDisSliderMaxFormat}}</label>
        </div>
        <div class="sld throw_dis_sld check">
          <el-slider v-model="throwDisSliderData" v-showTipDis ref="throwDisSliderFlag" @change="throwDisChanged" :disabled="screen_size_checked || real_throw_distance_checked" :show-tooltip="false" class="throw_distance_slider pjy-slider-T" :step="0.001" :min="throwDisSliderMin" :max="throwDisSliderMax" :class="screen_size_checked ? 'none':'block'"></el-slider>
        </div>
        </div>
      </div>
  </div>
</div>

</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import dropdown from '@/components/Dropdown'
import Header from '@/components/header'
export default {
  name: 'lensList',
  props: ['showConditionFlag'],
  data () {
    return {
      activeNames: ['1', '2'],
      switch_width: 58,
      lock_checked: true,
      offsetData: '',
      floor2bottomData: '',
      depth_input: 0,
      waring_icon: false,
      aspect: [
        {
          value: '1',
          label: '1'
        }
      ],
      appSelectData: [{
        value: '0',
        globalKey: 'T_MEETING_ROOM',
        label: this.$t('T_MEETING_ROOM')
      }, {
        value: '1',
        globalKey: 'T_CLASS_ROOM',
        label: this.$t('T_CLASS_ROOM')
      }, {
        value: '2',
        globalKey: 'T_EVENT_HALL',
        label: this.$t('T_EVENT_HALL')
      }, {
        value: '3',
        globalKey: 'T_LIVING_ROOM',
        label: this.$t('T_LIVING_ROOM')
      }, {
        value: '4',
        globalKey: 'T_THEATRE_ROOM',
        label: this.$t('T_THEATRE_ROOM')
      }, {
        value: '5',
        globalKey: 'T_CUSTOM',
        label: this.$t('T_CUSTOM')
      }],
      room: '0',
      shape: [
        {
          value: '1',
          label: '1'
        }
      ],
      shape_input: '',
      angle: [
        {
          value: '1',
          label: '1'
        }
      ],
      angle_input: '',
      roomWData: '',
      roomHData: '',
      roomDData: '',
      pjYData: '',
      scrnWData: '',
      scrnHData: '',
      screenSizeData: '',
      gainData: '',
      vAngleData: '',
      hAngleData: '',
      errorMsg: {
        number: ''
      },
      unitDataOptions: [{
        value: 'T_METRE_M',
        simplify: 'm',
        globalKey: 'T_METRE_M',
        label: this.$t('T_METRE_M')
      }, {
        value: 'T_MILLIMETER_MM',
        simplify: 'mm',
        globalKey: 'T_MILLIMETER_MM',
        label: this.$t('T_MILLIMETER_MM')
      }, {
        value: 'T_FEET_DECIMAL',
        simplify: 'ft',
        globalKey: 'T_FEET_DECIMAL',
        label: this.$t('T_FEET_DECIMAL')
      }, {
        value: 'T_INCH_DECIMAL',
        simplify: 'inch',
        globalKey: 'T_INCH_DECIMAL',
        label: this.$t('T_INCH_DECIMAL')
      }, {
        value: 'T_FEET_FRACTION',
        simplify: 'ft',
        globalKey: 'T_FEET_FRACTION',
        label: this.$t('T_FEET_FRACTION')
      }, {
        value: 'T_INCH_FRACTION',
        simplify: 'inch',
        globalKey: 'T_INCH_FRACTION',
        label: this.$t('T_INCH_FRACTION')
      }],
      rules: {
        'number': [{
          required: true,
          message: '必填'
        },
        {
          type: 'number',
          message: '请输入数字'
        }
        ]
      },
      ustOffsetMaxVal: 10,
      throw_distance_slider: [100, 200],
      // diagonal对角线最大最小值
      diagonalMin: 0,
      diagonalMax: 0,
      diagonalSliderCurrent: 0,
      throwDisSliderMin: 0,
      throwDisSliderMax: 0,
      throwDisSliderw: 0,
      throwDisSlidert: 0,
      throwDisSliderWidth: 0,
      currentDistData: [],
      dwhSelectOptions: [
        {
          value: '0',
          globalKey: 'T_DIAGONAL',
          label: this.$t('T_DIAGONAL')
        }, {
          value: '1',
          globalKey: 'T_WIDTH',
          label: this.$t('T_WIDTH')
        }, {
          value: '2',
          globalKey: 'T_HEIGHT',
          label: this.$t('T_HEIGHT')
        }
      ],
      dwhSelect: '0',
      currentSizeW: 0,
      currentSizet: 0,
      dwhData: 0,
      throwdisCurrnet: 0,
      throwDisChangedSizeLockedCurrent: 0,
      slidervalue: 0,
      outOfSpecDialogStatus: false,
      dwhDataDetailData: 0,
      ratioScreenSizeMin: 0,
      ratioScreenSizeMax: 0,
      realThrowDisSliderRangeMax: 0,
      labLeft: '',
      floor2footProjectorData: '',
      isLShaped: this.$commonViewJs.isLShaped(),
      isLShaped01: this.$commonViewJs.isLShaped01(),
      leftWall2topData: '',
      ceiling_bottomProjector_checked: false,
      ceiling2bottomProjectorData: '',
      wall_wallProjector_checked: false,
      wall2WallProjectorData: '',
      floor2rearProjectorData: '',
      floor2frontProjectorData: ''
    }
  },
  created () {
  },

  directives: {
    showTip (el, binding, vnode) {
      let se = vnode.context.dwhSelect
      let tip = se === '0' ? vnode.context.screenSizeData : (se === '1' ? vnode.context.scrnWData : (se === '2' ? vnode.context.scrnHData : 0))
      let target = el.getElementsByClassName('el-slider__button-wrapper')[0]
      if (target.getElementsByTagName('label')[0]) {
        target.getElementsByTagName('label')[0].innerText = tip
      } else {
        let addNode = `<label class="lab" style="position: absolute;top: -7px;">` + tip + `</label>`
        target.innerHTML = addNode + target.innerHTML
      }
    },
    showTipDis (el, binding, vnode) {
      let target = el.getElementsByClassName('el-slider__button-wrapper')[0]
      if (!vnode.context.real_throw_distance_checked) {
        if (target.getElementsByTagName('label')[0]) {
          target.getElementsByTagName('label')[0].remove()
        }
        return
      }
      let tip = vnode.context.pjYData
      if (target.getElementsByTagName('label')[0]) {
        target.getElementsByTagName('label')[0].innerText = tip
      } else {
        let addNode = `<label class="lab" v-if="false" style="position: absolute;top: -7px;">` + tip + `</label>`
        target.innerHTML = addNode + target.innerHTML
      }
    }
  },

  mounted () {
    this.initData()
    if (this.searchParams.tbd) {
      if (this.searchParams.aspectRatioData) {
        this.ASPECTRATIO(this.searchParams.aspectRatioData)
      }
      if (this.searchParams.dwhSelect) {
        this.dwhSelect = this.searchParams.dwhSelect
      }
      if (this.searchParams.screenSizeData) {
        this.dwhDataDetailData = this.searchParams.screenSizeData
        this.changeDwhData(this.dwhDataDetailData)
      }
      if (this.searchParams.appSelect) {
        this.SET_APPLICATION(this.searchParams.appSelect)
      }
      if (this.searchParams.brightness) {
        this.SET_BRIGHTNESS(this.searchParams.brightness)
      }
    }
  },
  filters: {
    filterFeet (value) {
      return value === 'inch' ? 'ft' : value
    }
  },
  methods: {
    backAction () {
      this.$emit('close')
    },

    onClickLeft () {
      this.$router.push({ path: '/' })
    },

    confirmAction () {
      this.$router.push({ path: '/' })
    },
    initData () {
      // console.log('initData this.position 1111', this.position)
      this.isLShaped = this.$commonViewJs.isLShaped()
      if (this.isSimple && this.isLShaped && (this.position !== 3 && this.position !== 4)) {
        this.changePosition('position', 4)
      } else if (!this.isLShaped && (this.position === 3 || this.position === 4)) {
        this.changePosition('position', 0)
      }
      // console.log('initData this.position 22222', this.position)
      this.isLShaped01 = this.$commonViewJs.isLShaped01()
      this.roomWData = this.$commonJs.changeUnit(this.roomW, this.graph.unit, false, true)
      this.roomHData = this.$commonJs.changeUnit(this.roomH, this.graph.unit, false, true)
      this.roomDData = this.$commonJs.changeUnit(this.roomD, this.graph.unit, false, true)

      let value = this.isUSTWall ? this.pjY - this.ustLensToFrontPj : this.$commonViewJs.getDistanceFromZorY()
      // console.log('initData this.pjYData', value, 'pjY', this.pjY, 'pjZ', this.pjZ, this.isLShaped01)
      this.pjYData = this.$commonJs.changeUnit(value, this.graph.unit)

      this.scrnWData = this.$commonJs.changeUnit(this.scrnW, this.graph.unit)
      this.scrnHData = this.$commonJs.changeUnit(this.scrnH, this.graph.unit)
      this.offsetData = this.$commonJs.changeUnit(this.offset, this.graph.unit)
      let data = this.drawData[0].reduce((data1, data2) => {
        return data1.z > data2.z ? data1 : data2
      })
      this.SET_FLOOR2BOTTOM(this.roomH - data.z)
      this.floor2bottomData = this.$commonJs.changeUnit(this.roomH - data.z, this.unit)
      this.floor2footProjectorData = this.floor2footProjectorComputed
      // this.floor2bottomData = this.$commonJs.changeUnit(this.floor2bottomComputed, this.graph.unit)
      this.screenSizeData = this.screenSizeDataComputed
      this.gainData = this.gainComputed
      this.vAngleData = this.vAngleDataComputed
      this.hAngleData = this.hAngleDataComputed
      this.SELECTRATIODATA(this.$commonJs.findSpecInfoByRatio(this.aspectRatio, this.selectedLensData))
      this.diagonalMin = this.selectRatioData.screenSize.w.min
      this.diagonalMax = this.selectRatioData.screenSize.w.max
      this.ratioScreenSizeMin = this.selectRatioData.screenSize.w.min
      this.ratioScreenSizeMax = this.selectRatioData.screenSize.w.max
      this.SET_RATIOSCREENSIZEMIN(this.selectRatioData.screenSize.w.min)
      this.SET_RATIOSCREENSIZEMAX(this.selectRatioData.screenSize.w.max)
      this.changeDiagonal()
      this.dwhData = this.screenSizeData
      this.leftWall2topData = this.getLeftWall2topData()
      this.ceiling_bottomProjector_checked = this.ceilingBottomProjectorChecked
      this.ceiling2bottomProjectorData = this.getCeiling2topData()
      this.wall_wallProjector_checked = this.wallWallProjectorChecked
      this.wall2WallProjectorData = this.getWall2WallData()
      this.floor2rearProjectorData = this.getFloor2rearProjector()
      this.floor2frontProjectorData = this.getFloor2frontProjector()
    },

    screenChanged () {
      this.screenSizeData = this.diagonalSliderCurrent
      this.changeScreenSize()
    },

    throwDisChangedSizeLocked () {
      // this.SET_GRAPH_PJY(this.throwDisChangedSizeLockedCurrent)
      this.throwDisChangedSizeLockedCurrent = this.$commonViewJs.getKy() + this.throwDisSliderRangeData - this.offset
      this.$commonViewJs.setZorYByDist(this.throwDisChangedSizeLockedCurrent)
    },

    throwDisChanged () {
      // this.SET_GRAPH_PJY(this.throwdisCurrnet)
      this.$commonViewJs.setZorYByDist(this.throwdisCurrnet)
      this.changeSliderDistance()
    },

    changeMutation (key, mutationKey, callBack, args = '') {
      if (this[key] === '') {
        this[key] = '0'
        // this.$toast('必填')
        // event.target.focus()
        // return false
      }
      if (key === 'pjYData') {
        let { max, min } = this.getPjyRange()
        this[key] = this.$commonJs.checkRange(this[key], min, max)
      }
      if (key === 'scrnWData') {
        let s = this.getScreenSizeRange()
        let size = this.$commonViewJs.getScreenSizeByCalX(this.$commonJs.changeUnit(this[key], this.graph.unit, true), this.aspectRatio)
        size = this.$commonJs.checkRange(size.size, s.min, s.max)
        let d = this.$commonViewJs.getScreenXYByScreenSize(size, this.aspectRatio).calX
        this[key] = this.$commonJs.changeUnit(d, this.graph.unit, false)
      }
      if (key === 'scrnHData') {
        let s = this.getScreenSizeRange()
        let size = this.$commonViewJs.getScreenSizeByCalY(this.$commonJs.changeUnit(this[key], this.graph.unit, true), this.aspectRatio)
        size = this.$commonJs.checkRange(size.size, s.min, s.max)
        let d = this.$commonViewJs.getScreenXYByScreenSize(size, this.aspectRatio).calY
        this[key] = this.$commonJs.changeUnit(d, this.graph.unit, false)
      }
      if (this.isUSTWall) {
        if (key === 'roomHData') {
          let { max, min } = this.getRhRange()
          this[key] = this.$commonJs.checkRange(this[key], min, max)
        }
        if (key === 'offsetData') {
          let { max, min } = this.getUstOffsetRange()
          this[key] = this.$commonJs.checkRange(this[key], min, max)
        }
      }
      if (key === 'offsetData' && !this.isUSTWall) {
        let temp = this.$commonJs.changeUnit(this.offsetData, this.graph.unit, true)
        let checkMax = this.houseInfo.roomD
        if (this.isLShaped01) {
          let disMin = this.$commonViewJs.calScreensizeToDistanceWide(this.ratioScreenSizeMin)
          checkMax = this.houseInfo.roomH - disMin
        }
        let lshapeLock = this.isLShaped &&
            ((this.position === 0 && this.floor_footProjector_checked) ||
            (this.position === 1 && this.ceiling_bottomProjector_checked) ||
            ((this.position === 3 || this.position === 4) && this.wall_wallProjector_checked)
            )
        if (temp > checkMax || lshapeLock) {
          this[key] = this.$commonJs.changeUnit(lshapeLock ? this.offset : checkMax, this.graph.unit, false)
        }
      }
      var temp = this.$commonJs.changeUnit(this[key], this.graph.unit, true)
      if (this.isSimple) {
        if (key === 'roomHData') {
          // let si = this.getSimpleRhRange()
          // let { max, min } = this.getSimpleRhRange()
          temp = this.$commonJs.checkRange(temp, 200, 2000)
        }
      }
      this[key] = this.$commonJs.changeUnit(temp, this.graph.unit, false)
      if (key === 'pjYData') {
        temp = this.isUSTWall ? temp + this.ustLensToFrontPj : temp
      }
      if (this.isLShaped01 && mutationKey === 'SET_GRAPH_PJY') {
        this.$commonViewJs.setZorYByDist(temp)
      } else {
        this[mutationKey](temp)
      }
      if (typeof this[callBack] === 'function') {
        this[callBack](args)
      }
      if (this.isOutOfSpec) {
        switch (key) {
          case 'roomDData':
            if (!this.isLShaped01 && this[key] * 1 < this.pjYData * 1) {
              this.SET_GRAPH_PJY(temp - this.offset)
            }
            break
          case 'roomHData':
            if (this.isLShaped01 && this[key] * 1 < this.pjYData * 1) {
              this.$commonViewJs.setZorYByDist(temp - this.offset)
            }
            break
          case 'pjYData':
            if (temp > (this.isLShaped01 ? this.roomH : this.roomD)) {
              this[`SET_GRAPH_${this.isLShaped01 ? 'ROOMH' : 'ROOMD'}`](temp + this.offset)
            }
            break
          default:
            break
        }
      }
    },

    getScreenSizeRange () {
      let distInfoVal = this.$commonJs.findCurrentDistInfo(this.selectedLensData)
      let maxDisByRoom = this.$commonViewJs.getMaxDisByRoom() - this.offset
      let lshapeLock = this.isLShaped &&
        ((this.position === 0 && this.floor_footProjector_checked) ||
         (this.position === 1 && this.ceiling_bottomProjector_checked) ||
         ((this.position === 3 || this.position === 4) && this.wall_wallProjector_checked)
        )
      let maxCheck, min, max
      if (this.real_throw_distance_checked) {
        if (this.dwhSelect === '0') {
          min = this.distanceLockedSizetFormat * 1
          max = this.distanceLockedSizewFormat * 1
        } else {
          let screenSizeTele = this.$commonJs.changeUnit(this.distanceLockedSizetFormat, this.graph.unit, true)
          let screenSizeWide = this.$commonJs.changeUnit(this.distanceLockedSizewFormat, this.graph.unit, true)
          if (this.dwhSelect === '1') {
            min = this.$commonViewJs.getScreenSizeByCalX(screenSizeTele, this.aspectRatio).size
            max = this.$commonViewJs.getScreenSizeByCalX(screenSizeWide, this.aspectRatio).size
          } else if (this.dwhSelect === '2') {
            min = this.$commonViewJs.getScreenSizeByCalY(screenSizeTele, this.aspectRatio).size
            max = this.$commonViewJs.getScreenSizeByCalY(screenSizeWide, this.aspectRatio).size
          }
          min = min < this.ratioScreenSizeMin ? this.ratioScreenSizeMin : min
          max = max < min ? min : max
        }
      } else if (lshapeLock) {
        min = (this.screenSize * 1).toFixed(2)
        max = min
      } else {
        if (this.isLShaped01) {
          // 投写距离在 房间高度范围内
          let distRoom = this.houseInfo.roomH - this.offset
          maxCheck = Math.min(maxDisByRoom, distRoom)
        } else {
          maxCheck = maxDisByRoom
        }
        let maxSize = this.$commonViewJs.getScreenByFromDistWide(maxCheck)
        min = this.isOutOfSpec ? 0 : distInfoVal.screenSize.w.min
        max = this.isOutOfSpec ? Number.POSITIVE_INFINITY : maxSize > distInfoVal.screenSize.w.max ? distInfoVal.screenSize.w.max : maxSize
        max = (max * 1).toFixed(2)
      }
      if (max * 1 < min * 1) { max = min }
      return {
        max: max,
        min: min
      }
    },

    getPjyRange () {
      let min = 0
      let max = 0
      let lshapeLock = this.isLShaped &&
        ((this.position === 0 && this.floor_footProjector_checked) ||
         (this.position === 1 && this.ceiling_bottomProjector_checked) ||
         ((this.position === 3 || this.position === 4) && this.wall_wallProjector_checked)
        )
      if (this.screen_size_checked) {
        min = this.$commonViewJs.getKy() - this.offset
        max = (this.$commonViewJs.getLy() > this.$commonViewJs.getMaxDisByRoom() ? this.$commonViewJs.getMaxDisByRoom() : this.$commonViewJs.getLy()) - this.offset
      } else if (lshapeLock) {
        min = this.$commonViewJs.getKy() - this.offset
        max = min
      } else if (this.isOutOfSpec) {
        min = 0
        max = Number.POSITIVE_INFINITY
      } else {
        let distInfoVal = this.$commonJs.findCurrentDistInfo(this.selectedLensData)
        let maxR = this.$commonViewJs.calScreensizeToDistanceWide(distInfoVal.screenSize.w.max)
        min = this.$commonViewJs.calScreensizeToDistanceWide(distInfoVal.screenSize.w.min)
        max = this.$commonViewJs.getMaxDisByRoom() - this.offset > maxR ? maxR : this.$commonViewJs.getMaxDisByRoom() - this.offset
      }
      if (this.isLShaped01 && !this.isOutOfSpec) {
        min = min < this.limitData ? this.limitData : min
        let distRoom = this.houseInfo.roomH - this.offset - this.limitData
        max = max > distRoom ? distRoom : max
      }
      min = this.isUSTWall ? min - this.ustLensToFrontPj : min
      max = this.isUSTWall ? max - this.ustLensToFrontPj : max

      min = this.$commonJs.changeUnit(min, this.graph.unit, false, false)
      max = this.$commonJs.changeUnit(max, this.graph.unit, false, false)
      return {
        max: max,
        min: min
      }
    },

    getPjyRangeNoChangeUnit () {
      let min = 0
      let max = 0
      if (this.screen_size_checked) {
        min = this.$commonViewJs.getKy() - this.offset
        max = (this.$commonViewJs.getLy() > this.$commonViewJs.getMaxDisByRoom() ? this.$commonViewJs
          .getMaxDisByRoom() : this.$commonViewJs.getLy()) - this.offset
      } else {
        let distInfoVal = this.$commonJs.findCurrentDistInfo(this.selectedLensData)
        let maxR = this.$commonViewJs.calScreensizeToDistanceWide(distInfoVal.screenSize.w.max)
        min = this.$commonViewJs.calScreensizeToDistanceWide(distInfoVal.screenSize.w.min)
        max = this.$commonViewJs.getMaxDisByRoom() - this.offset > maxR ? maxR : this.$commonViewJs
          .getMaxDisByRoom() - this.offset
      }
      if (this.isLShaped01) {
        min = min < this.limitData ? this.limitData : min
        let distRoom = this.houseInfo.roomH - this.offset - this.limitData
        max = max > distRoom ? distRoom : max
      }
      return {
        max: max,
        min: min
      }
    },

    /**
       * 在修改房间大小时，设置投影仪不出房间
       */
    changeRoomH () {
      if (this.graph.pjZ < this.limitData) {
        this.PJZ(this.limitData)
      } else if (this.graph.pjZ > this.houseInfo.roomH - this.limitData) {
        this.PJZ(this.houseInfo.roomH - this.limitData)
      }
    },

    changeRoomW () {
      if (this.graph.pjX < this.limitData) {
        this.PJX(this.limitData)
      } else if (this.graph.pjX > this.houseInfo.roomW - this.limitData) {
        this.PJX(this.houseInfo.roomW - this.limitData)
      }
    },
    getRhRange () {
      let min = 0
      let max = 0
      min = this.$commonJs.changeUnit(200, this.graph.unit, false, false)
      max = this.$commonJs.changeUnit(500, this.graph.unit, false, false)
      return {
        max: max,
        min: min
      }
    },

    getSimpleRhRange () {
      let min = 0
      let max = 0
      min = this.$commonJs.changeUnit(200, this.graph.unit, false, true)
      max = this.$commonJs.changeUnit(2000, this.graph.unit, false, true)
      return {
        max: max,
        min: min
      }
    },
    getUstOffsetRange () {
      let min = 0
      let max = 0
      min = this.$commonJs.changeUnit(0, this.graph.unit, false, true)
      // ArmLenMax = 0の場合,対象機種Aなので、Wall2ScreenMax = 100mmで終了
      if (this.selectedModelData.ArmLenMax === 0) {
        max = this.$commonJs.changeUnit(10, this.graph.unit, false, true)
      } else {
        max = this.ustOffsetMax
      }
      return {
        max: max,
        min: min
      }
    },
    changGainMutation () {
      if (this.gainData === '') {
        this.gainData = '0'
        // this.$toast('必填')
        // event.target.focus()
        // return false
      }
      this['SET_GAIN']((this.gainData * 1).toFixed(1))
    },

    changBrightnessMutation () {
      if (this.brightnessData === '') {
        this.brightnessData = '0'
        // this.$toast('必填')
        // event.target.focus()
        // return false
      }
      this['SET_BRIGHTNESS']((this.brightnessData * 1).toFixed(1))
    },

    // 改变floor2bottom，要改变pjz，但是不能再watch的时候改
    changeFloorMutation () {
      if (!this.floor_footProjector_checked && !(!this.isLShaped && this.ceiling_bottomProjector_checked)) {
        if (this.floor2bottomData === '') {
          this.floor2bottomData = '0'
        // this.$toast('必填')
        // event.target.focus()
        // return false
        }
        var temp = this.$commonJs.changeUnit(this.floor2bottomData, this.graph.unit, true)
        this.floor2bottomData = this.$commonJs.changeUnit(temp, this.graph.unit)
        let temoPjz = this.graph.pjZ - (temp - this.floor2bottom)
        if (temoPjz < this.limitData) {
          temoPjz = this.limitData
          temp = this.graph.pjZ - temoPjz + this.floor2bottom
          this.floor2bottomData = this.$commonJs.changeUnit(temp, this.graph.unit)
        }
        this.PJZ(temoPjz)
        this.SET_FLOOR2BOTTOM(temp)
      } else {
        let projectorCenterToBottom = this.houseInfo.roomH - this.$commonViewJs.getAz()
        let temp = this.$commonJs.changeUnit(this.floor2bottomData, this.graph.unit, true)
        let { max, min } = this.getPjyRange()
        let pjYNewData = ((Number(this.graph.pjY) / 100)) / (projectorCenterToBottom - Number(this.floor2bottom)) * (projectorCenterToBottom - Number(temp))
        let value = pjYNewData
        pjYNewData = this.$commonJs.checkRange(value, min, max)
        this.floor2bottomData = this.$commonJs.changeUnit(this.floor2bottom, this.graph.unit)
        this.PJY((pjYNewData * 100))
      }
    },

    changeFloor2footProjector () {
      let BrightnessDataFe = this.getBrightnessFe
      let floor2foot = this.$commonJs.changeUnit(this.floor2footProjectorData, this.graph.unit, true)
      let temoPjz
      if (this.selectedModelData.lensExchange === true) {
        if (this.isLShaped && this.position === 0) {
          let property = this.$commonJs.getBrightnessPJProperty()
          if (this.real_throw_distance_checked) {
            temoPjz = this.graph.pjZ
            this.floor2footProjectorData = this.$commonJs.changeUnit(this.houseInfo.roomH - temoPjz - this.offset - property.pjheight, this.graph.unit, false)
          } else {
            temoPjz = this.houseInfo.roomH - floor2foot - this.offset - property.pjheight
            let { max, min } = this.getPjyRangeNoChangeUnit()
            temoPjz = this.$commonJs.checkRange(temoPjz, min, max)
            this.floor2footProjectorData = this.$commonJs.changeUnit(this.houseInfo.roomH - temoPjz - this.offset - property.pjheight, this.graph.unit, false)
            this.PJZ(temoPjz)
            if (this.throw_distance_checked) this.changeDistance()
          }
        } else {
          temoPjz = this.houseInfo.roomH - floor2foot - BrightnessDataFe
          this.PJZ(temoPjz)
        }
      } else {
        if (floor2foot > (this.houseInfo.roomH - this.selectedLensData.fe)) {
          this.floor2footProjectorData = this.$commonJs.changeUnit(this.houseInfo.roomH - this.selectedLensData.fe, this.graph.unit, false)
        }
        temoPjz = this.houseInfo.roomH - floor2foot - this.selectedLensData.fe
        this.PJZ(temoPjz)
      }
    },

    // 改距离，影响宽,高,对角线
    changeDistance () {
      if (this.screenSizeChecked) {
        this.checkIsElectron()
        return
      }
      if (this.throwDistanceChecked) {
        this.changeDistanceOnThrowDisLocked()
      } else {
        // let result = this.$commonViewJs.getScreenByFromDistWide(this.graph.pjY)
        // this.changePjy(this.graph.pjY)
        let dist = this.$commonViewJs.getDistanceFromZorY()
        let result = this.$commonViewJs.getScreenByFromDistWide(dist)
        this.checkScreenSize(result)
      }
    },

    // 改距离，影响宽,高,对角线
    changeSliderDistance () {
      if (this.screen_size_checked) {
        this.checkIsElectron()
        return
      }
      if (this.throw_distance_checked) {
        this.changeDistanceOnThrowDisLocked()
      } else {
        this.changePjy()
      }
    },

    checkIsElectron () {
      let flag = 1
      if (this.position === 1) {
        flag = -1
      }
      let dist = this.$commonViewJs.getDistanceFromZorY()
      // 计算当当前投影仪不为超短焦，并且为电子变焦时
      if (this.$commonViewJs.isLongLensExistsLens() && this.$commonViewJs.isLongLensExistsTLens()) {
        let vlensShiftN
        let defaultDistInfo = this.selectRatioData
        if (this.screenSizeChecked) {
          let wSize = this.$commonViewJs.getScreenSizeFromDist(dist)
          let wSizeInch = this.$commonViewJs.getScreenByFromDistWide(dist)
          let l = (wSize.calY - this.graph.scrnH) / 2
          let v2 = defaultDistInfo.wv.wv2 * wSizeInch
          let v2l = v2 - l
          vlensShiftN = (v2l - this.graph.scrnH / 2) / this.initScreenSize.h * flag
        } else {
          vlensShiftN = (defaultDistInfo.wv.wv2 * this.screenSize - this.graph.scrnH / 2) / this.initScreenSize.h * flag
        }
        this.SET_VLENSSHIFT(vlensShiftN)
        let vals = {}
        vals.max = vlensShiftN
        vals.min = vlensShiftN
        this.VLENSSHIFT(vals)
        let ll = {}
        ll.max = vlensShiftN * flag
        ll.min = vlensShiftN * flag
        this.SET_TEMVLENSSHIFT(ll)
      }
    },

    checkScreenSizeNoPjy (screenSize) {
      // let {max, min} = this.getScreenSizeRange()

      // this.screenSizeData - screenSizeTele
      // console.log(this.screenSizeData)
      // console.log(screenSizeTele)
      // console.log('------------------------------')
      // console.log(screenSize)
      let dist = this.$commonViewJs.getDistanceFromZorY()
      let screenSizeTele = this.$commonViewJs.getScreenByFromDistTele(dist)
      let screenSizeWele = this.$commonViewJs.getScreenByFromDistWide(dist)
      screenSize = this.$commonJs.checkRange(screenSize, screenSizeTele, screenSizeWele)
      this.SET_SCREENSIZE(screenSize)
      // this.screenSizeData = screenSize.toFixed(2)
      let wh = this.$commonViewJs.getScreenXYByScreenSize(screenSize, this.aspectRatio)
      this.SCRNW(wh.calX)
      this.SCRNH(wh.calY)
      let initXY = this.$commonViewJs.getInitScreenXyFromDist(this.$commonViewJs.getKy() - this.offset)
      this.SET_INITSCREENSIZEW(initXY.calX)
      this.SET_INITSCREENSIZEH(initXY.calY)

      if (this.throwDistanceChecked) {
        if (this.isLShaped01) {
          this.PJY(this.flToB + initXY.calY / 2 + initXY.calY * this.vLensShiftNow / 100)
        } else {
          this.PJZ(this.houseInfo.roomH - (this.flToB + initXY.calY / 2 - initXY.calY * this.vLensShiftNow / 100))
        }
        this.PJX(this.flToL + initXY.calX / 2 - initXY.calX * this.hLensShiftNow / 100)
      }
      // ==========================================================================================================================================
      // var initScreen = this.$commonViewJs.getInitScreenXyFromDist(this.graph.pjY)
      //   this.SET_INITSCREENSIZEW(initScreen.calX)
      //   this.SET_INITSCREENSIZEH(initScreen.calY)
      //   this.SCREENSIZE(this.$commonViewJs.getScreenByFromDistWide(this.graph.pjY))
      //   let screen = this.$commonViewJs.getScreenXyFromDist(this.graph.pjY)
      //   this.SCRNW(screen.calX)
      //   this.SCRNH(screen.calY)
    },

    // ThrowDistance改距离，影响宽,高,对角线
    changeDistanceOnThrowDisLocked () {
      let dist = this.$commonViewJs.getDistanceFromZorY()
      let result = this.$commonViewJs.getScreenByFromDistWide(dist)
      this.checkScreenSize(result)
      let screenSi = this.$commonViewJs.getInitScreenXyFromDist(dist)
      if (this.isLShaped01) {
        this.PJY(this.flToB + screenSi.calY / 2 + screenSi.calY * this.vLensShiftNow / 100)
      } else {
        this.PJZ(this.houseInfo.roomH - (this.flToB + screenSi.calY / 2 - screenSi.calY * this.vLensShiftNow / 100))
      }
      this.PJX(this.flToL + screenSi.calX / 2 - screenSi.calX * this.hLensShiftNow / 100)
    },

    changePjy () {
      let dist = this.$commonViewJs.getDistanceFromZorY()
      let result = this.$commonViewJs.getScreenByFromDistWide(dist)
      this.SET_SCREENSIZE(result)
      this.throwDisSliderw = this.$commonViewJs.getKy()
      this.throwDisSlidert = this.$commonViewJs.getLy()
    },

    // 判断屏幕距离是否合法
    checkScreenSize (screenSize) {
      let { max, min } = this.getScreenSizeRange()
      screenSize = this.$commonJs.checkRange(screenSize, min, max)
      this.SET_SCREENSIZE(screenSize)
      let lshapeLock = this.isLShaped &&
        ((this.position === 0 && this.floor_footProjector_checked) ||
         (this.position === 1 && this.ceiling_bottomProjector_checked) ||
         ((this.position === 3 || this.position === 4) && this.wall_wallProjector_checked)
        )
      if (!this.real_throw_distance_checked && !lshapeLock) {
        let distance = this.$commonViewJs.calScreensizeToDistanceWide(screenSize)
        this.$commonViewJs.setZorYByDist(distance)
        this.resetScreenByPjy()
        this.throwDisSliderw = this.$commonViewJs.getKy()
        this.throwDisSlidert = this.$commonViewJs.getLy()
        if (distance >= (this.isLShaped01 ? this.roomH : this.roomD)) {
          this[this.isLShaped01 ? 'SET_GRAPH_ROOMH' : 'SET_GRAPH_ROOMD'](distance)
        }
      }
    },

    // 当screenSize锁定时，切换镜头或者投影仪
    changeDistanceOnSizeLocked () {
      this.screenSizeData = (this.screenSize * 1).toFixed(2)

      // 当screenSize锁定时，切换投影仪或者镜头，如果当前尺寸小于当前投影仪的最小尺寸，则切换成最小尺寸
      this.checkScreenSize(this.screenSizeData)
      this.changeScreenSize()
    },

    // 改变宽，影响高, 对角线 ==> 距离
    changeScreenW () {
      // 高
      let tempArray = this.aspectRatioData.split(':')
      // this.SET_GRAPH_SCRNH(this.graph.scrnW * tempArray[1] / tempArray[0])
      // 对角线
      let screenSize = Math.sqrt(Math.pow(this.graph.scrnW, 2) + Math.pow(this.graph.scrnW * tempArray[1] / tempArray[0], 2)) / 2.54
      this.screenSizeData = screenSize
      this.changeScreenSize()
    },

    // 改变高，影响宽, 对角线 ==> 距离
    changeScreenH () {
      // 宽
      let tempArray = this.aspectRatioData.split(':')
      // this.SET_GRAPH_SCRNW(this.graph.scrnH * tempArray[0] / tempArray[1])
      // 对角线
      let screenSize = Math.sqrt(Math.pow(this.graph.scrnH, 2) + Math.pow(this.graph.scrnH * tempArray[0] / tempArray[1], 2)) / 2.54
      this.screenSizeData = screenSize
      this.changeScreenSize()
    },

    // 改变对角线，影响距离 ==> 宽高
    changeScreenSize () {
      let { max, min } = this.getScreenSizeRange()
      // console.log('changeScreenSize min', min, 'max', max)
      this.screenSizeData = this.$commonJs.checkRange(this.screenSizeData, min, max)
      this.SET_SCREENSIZE(this.screenSizeData)
      // this.dwhDataDetailData = this.screenSizeData
      this.dwhData = this.screenSizeData
      let lshapeLock = this.isLShaped &&
        ((this.position === 0 && this.floor_footProjector_checked) ||
         (this.position === 1 && this.ceiling_bottomProjector_checked) ||
         ((this.position === 3 || this.position === 4) && this.wall_wallProjector_checked)
        )
      if (!this.real_throw_distance_checked && !lshapeLock) {
        let distance = this.$commonViewJs.calScreensizeToDistanceWide(this.screenSize)
        this.$commonViewJs.setZorYByDist(distance)
        if (this.isOutOfSpec && distance >= (this.isLShaped01 ? this.roomH : this.roomD)) {
          this[this.isLShaped01 ? 'SET_GRAPH_ROOMH' : 'SET_GRAPH_ROOMD'](distance)
        }
      }
      // var initScreen = this.$commonViewJs.getInitScreenXyFromDist(this.graph.pjY)
      // this.SET_INITSCREENSIZEW(initScreen.calX)
      // this.SET_INITSCREENSIZEH(initScreen.calY)
      // let result = this.$commonViewJs.getScreenXyFromDist(this.graph.pjY)
      // this.SET_GRAPH_SCRNW(result.calX)
      // this.SET_GRAPH_SCRNH(result.calY)
      this.isPositionChecked()
    },

    // 在改变投影仪的房间信息时，判断position是否选中
    isPositionChecked () {
      if (this.throwDistanceChecked) {
        let dist = this.$commonViewJs.getDistanceFromZorY()
        var initScreen = this.$commonViewJs.getInitScreenXyFromDist(dist)
        if (this.isLShaped01) {
          this.PJY(this.flToB + initScreen.calY / 2 + initScreen.calY * this.vLensShiftNow / 100)
        } else {
          this.PJZ(this.houseInfo.roomH - (this.flToB + initScreen.calY / 2 - initScreen.calY * this.vLensShiftNow / 100))
        }
        this.PJX(this.flToL + initScreen.calX / 2 - initScreen.calX * this.hLensShiftNow / 100)
      }
    },

    changeDwhSelect () {
      let defaultDistData = this.selectRatioData
      this.currentDistData = defaultDistData.throwRange.w
      let screenMin = defaultDistData.screenSize.w.min
      let screenMax = defaultDistData.screenSize.w.max
      if (this.dwhSelect === '0') {
        this.dwhData = parseFloat((this.screenSizeData)).toFixed(2)
        this.diagonalMin = screenMin
        this.diagonalMax = screenMax
      } else if (this.dwhSelect === '1') {
        this.dwhData = this.graph.scrnW
        this.diagonalMin = parseFloat(this.$commonViewJs.getScreenXYByScreenSize(screenMin, this.aspectRatio).calX)
        this.diagonalMax = parseFloat(this.$commonViewJs.getScreenXYByScreenSize(screenMax, this.aspectRatio).calX)
      } else if (this.dwhSelect === '2') {
        this.dwhData = this.graph.scrnH
        this.diagonalMin = parseFloat(this.$commonViewJs.getScreenXYByScreenSize(screenMin, this.aspectRatio).calY)
        this.diagonalMax = parseFloat(this.$commonViewJs.getScreenXYByScreenSize(screenMax, this.aspectRatio).calY)
      }
    },

    // 改变比率，距离不变 ==> 影响宽,高,对角线
    changeAspectRatio (value) {
      this.selectedLensData_lcd_distInfo.forEach((item) => {
        if (item.ratio === value) {
          this.F_S2D(item.size2dist)
          this.F_D2S(item.dist2size)
        }
        if (this.screenSizeChecked) {
          let distance = this.$commonViewJs.calScreensizeToDistanceWide(this.screenSize)
          this.$commonViewJs.setZorYByDist(distance)
          this.SET_BLACKSIZE(this.$commonViewJs.calDistanceInitToScreensizeWide(distance))
          let dist = this.$commonViewJs.getDistanceFromZorY()
          var initScreen = this.$commonViewJs.getInitScreenXyFromDist(dist)
          this.SET_INITSCREENSIZEW(initScreen.calX)
          this.SET_INITSCREENSIZEH(initScreen.calY)
          if (this.throwDistanceChecked) {
            this.PJX(this.flToL + this.initScreenSize.w / 2 - this.initScreenSize.w * this.hLensShiftNow / 100)
            if (this.isLShaped01) {
              this.PJY(this.flToB + this.initScreenSize.h / 2 + this.initScreenSize.h * this.vLensShiftNow / 100)
            } else {
              this.PJZ(this.houseInfo.roomH - (this.flToB + this.initScreenSize.h / 2 - this.initScreenSize.h * this.vLensShiftNow / 100))
            }
          }
        }
      })
      this.SELECTRATIODATA(this.$commonJs.findSpecInfoByRatio(this.aspectRatio, this.selectedLensData))
    },

    changeBrightness (value) {
      var temp
      if (value === '0') {
        temp = 200
      } else if (value === '1') {
        temp = 300
      } else if (value === '2') {
        temp = 200
      } else if (value === '3') {
        temp = 100
      } else if (value === '4') {
        temp = 20
      } else if (value === '5') {
        temp = 300
      }
      this['SET_APPLICATION'](value)
      this['SET_BRIGHTNESS'](temp)
    },

    testDigital (e, key) {
      if (this.unitData !== 'T_FEET_FRACTION' && this.unitData !== 'T_INCH_FRACTION') {
        e = e.replace(/[^0-9|.]/ig, '')
        let n = (this[key].split('.') || []).length - 1
        if (n > 1) {
          e = ''
        }
        this[key] = e
      } else {
        e = e.replace(/[^ \d|\-|'|"|/]/ig, '')
        this[key] = e
      }
    },

    testDigitalNegative (e, key) {
      e = e.replace(/[^(\-|+)0-9|.]/ig, '')
      if (e !== '-') {
        this[key] = e
      }
    },
    switchchange (data) {
      data === true ? this.waring_icon = true : this.waring_icon = false
      if (data) {
        this.outOfSpecDialogStatus = true
      }
    },

    changeAngle (key, commit) {
      if (this[key]) {
        this[commit](!this[key])
      }
    },

    changeAngleData (key, commit) {
      if (this[key]) {
        this[key] = (this[key] * 1).toFixed(1)
        this[commit](this[key] * 1)
      }
    },

    changePosition () {
      this[arguments[0]] = arguments[1]
      let value = arguments[1]
      if (value === 1 || value === 2) {
        let vals = {}
        vals.max = this.temVLensShift.min * (-1)
        vals.min = this.temVLensShift.max * (-1)
        this.VLENSSHIFT(vals)
        if (vals.max < 0) {
          this.SET_VLENSSHIFT(vals.max * 100)
        } else if (this.vLensShiftNow) {
          this.SET_VLENSSHIFT(0)
        }
      } else if (value === 0) {
        let vals = {}
        vals.max = this.temVLensShift.max
        vals.min = this.temVLensShift.min
        this.VLENSSHIFT(vals)
        if (vals.min > 0) {
          this.SET_VLENSSHIFT(vals.min * 100)
        } else if (this.vLensShiftNow) {
          this.SET_VLENSSHIFT(0)
        }
      }

      this.SET_HLENSSHIFT(0)
      this.SET_POSITION(value)
      this.SET_OTHER_POSITION(value)
      this.isLShaped = this.$commonViewJs.isLShaped()
      this.isLShaped01 = this.$commonViewJs.isLShaped01()
      if (this.isLShaped && !this.isSimple) {
        this.changeMutation('offsetData', 'SET_OFFSET')
        let dist = this.$commonJs.changeUnit(this.pjYData, this.graph.unit, true)
        this.$commonViewJs.setZorYByDist(dist)
        this.changeScreenSize()
      }

      if (value === 2) {
        this.SET_ISUSTWALL(true)
      } else {
        this.SET_ISUSTWALL(false)
      }
    },
    changeFingerTouchStatus (value) {
      if (!this.isUSTWall) {
        return
      }
      this.SET_FINGERTOUCHSTATUS(value)
    },

    changeDiagonal () {
      let defaultDistData = this.selectRatioData
      this.currentDistData = defaultDistData.throwRange.w
      this.throwDisSliderMin = this.$commonViewJs.calScreensizeToDistanceWide(this.selectRatioData.screenSize.w.min)
      this.throwDisSliderMax = this.$commonViewJs.calScreensizeToDistanceTele(this.selectRatioData.screenSize.w.max)
      this.throwDisSliderw = this.$commonViewJs.getKy()
      this.throwDisSlidert = this.$commonViewJs.getLy()
      this.throwDisSliderWidth = (this.throwDisSlidert - this.throwDisSliderw) / (this.throwDisSliderMax - this.throwDisSliderMin) * 100
      this.throwDisWidth()
    },

    throwDisSliderDataFormat (val) {
      return this.$commonJs.changeUnit(Number(val) + this.throwDisSliderMin, this.graph.unit, false, true)
    },
    throwDisSliderCurrentFormat (val) {
      return this.$commonJs.changeUnit(this.graph.pjY, this.graph.unit, false, true)
    },
    getLimitDistance (val) {
      // eslint-disable-next-line no-unused-vars
      let { min, max } = this.getPjyRangeNoChangeUnit()
      if (val > max) {
        return max
      } else {
        return val
      }
    },
    throwDisWidth () {
      if (this.$refs.throwDisSliderRangeFlag) {
        // let nowPjyT = this.$commonViewJs.getLy()
        // let persentT = (nowPjyT - this.throwDisSliderMin) / (this.throwDisSliderMax - this.throwDisSliderMin)
        // let persent = persentT * 100
        // let d = (this.throwDisSlidert - this.throwDisSliderw) / (this.throwDisSliderMax - this.throwDisSliderMin) * 100
        // if (persent > 100) {
        //   this.throwDisSliderWidth = d - (persent - 100)
        // }
        if (this.throwDisSliderMaxFormat === this.throwDisSliderwFormat) {
          this.$refs.throwDisSliderRangeFlag.$el.style.width = 0 + '%'
        } else {
          this.$refs.throwDisSliderRangeFlag.$el.style.width = this.throwDisSliderWidth + '%'
        }
      }
    },
    /**
     * 计算screen size栏
     */
    screenSizeWidth (width) {
      let dist = this.$commonViewJs.getDistanceFromZorY()
      let screenSizeTele = this.$commonViewJs.getScreenByFromDistTele(dist)
      let screenSizeWide = this.screenSize
      if (width) screenSizeWide = width
      screenSizeTele = screenSizeTele < this.ratioScreenSizeMin ? this.ratioScreenSizeMin : screenSizeTele
      screenSizeWide = screenSizeWide < screenSizeTele ? screenSizeTele : screenSizeWide
      this.realThrowDisSliderRangeMax = screenSizeWide - screenSizeTele
      let defaultDistData = this.selectRatioData
      let sizeDis = defaultDistData.screenSize.w.max - defaultDistData.screenSize.w.min
      this.$refs.realThrowDisSliderRangeFlag.$el.style.left = (screenSizeTele - defaultDistData.screenSize.w.min) / sizeDis * 100 + '%'
      this.$refs.realThrowDisSliderRangeFlag.$el.style.width = this.realThrowDisSliderRangeMax / sizeDis * 100 + '%'
      let lef = (screenSizeTele - defaultDistData.screenSize.w.min) / sizeDis * 100
      this.$refs.distanceLockedSizetFormat.style.left = lef - 5 + '%'
      this.$refs.distanceLockedSizewFormat.style.left = (this.screenSizeData - defaultDistData.screenSize.w.min) / sizeDis * 100 - 5 + '%'
    },

    formatTooltipScreenSize (val) {
      return this.dwhSelect === '0' ? val : this.$commonJs.changeUnit(val, this.graph.unit, false, true)
    },

    showOutOfSpecDialog () {
      this.outOfSpecDialogStatus = true
    },

    resetScreenByPjy () {
      // 获取黑边的长宽
      let dist = this.$commonViewJs.getDistanceFromZorY()
      var initScreen = this.$commonViewJs.getInitScreenXyFromDist(dist)
      this.SET_INITSCREENSIZEW(initScreen.calX)
      this.SET_INITSCREENSIZEH(initScreen.calY)
      this.SCREENSIZE(this.$commonViewJs.getScreenByFromDistWide(dist))
      let screen = this.$commonViewJs.getScreenXyFromDist(dist)
      this.SCRNW(screen.calX)
      this.SCRNH(screen.calY)
    },

    // 左壁からスクリーン上端まで
    getLeftWall2topData () {
      let leftWall2top = this.$commonViewJs.getAy() - this.scrnH / 2 - this.scrnH * this.vLensShiftNow / 100
      leftWall2top = leftWall2top < 0 ? 0 : leftWall2top
      return this.$commonJs.changeUnit(leftWall2top, this.graph.unit)
    },
    changeLeftWall2top () {
      let leftWall2top = this.$commonJs.changeUnit(this.leftWall2topData, this.graph.unit, true)
      let max = this.houseInfo.roomD - this.scrnH / 2 - this.scrnH * this.vLensShiftNow / 100
      if (leftWall2top > max) {
        leftWall2top = max - this.limitData
        this.leftWall2topData = this.$commonJs.changeUnit(leftWall2top, this.graph.unit, false)
      }
      let tempY = leftWall2top + this.scrnH / 2 + this.scrnH * this.vLensShiftNow / 100
      this.SET_GRAPH_PJY(tempY)
    },

    // 天井から天吊り金具取付部まで
    getCeiling2topData () {
      let f2l = this.houseInfo.roomH - this.graph.pjZ < 0 ? 0 : this.houseInfo.roomH - this.graph.pjZ
      let c2top = 0
      if (this.selectedModelData.lensExchange === true) {
        let property = this.$commonJs.getBrightnessPJProperty()
        if (this.selectedLensData.id.indexOf('LX') > -1) {
          if (this.$commonViewJs.isLShaped() && this.position === 1) {
            c2top = this.graph.pjZ - this.offset - (property.cc + property.mu)
          } else {
            c2top = this.houseInfo.roomH - (f2l + property.cc + property.mu)
          }
        } else {
          c2top = this.houseInfo.roomH - (f2l + property.mu)
        }
      } else {
        c2top = this.houseInfo.roomH - (f2l + this.selectedLensData.mu)
      }
      return this.$commonJs.changeUnit(c2top, this.graph.unit)
    },
    changeCeiling2bottomProjectorChecked () {
      this.SET_CEILINGBOTTOMPROJECTORCHECKED(this.ceiling_bottomProjector_checked)
    },
    changeCeiling2bottomProjector () {
      let BrightnessDataMu = this.selectedLensData.mu
      let BrightnessDataCc = 0
      let ceiling2bottom = this.$commonJs.changeUnit(this.ceiling2bottomProjectorData, this.graph.unit, true)
      let temoPjz
      let property = this.$commonJs.getBrightnessPJProperty()
      if (this.selectedModelData.lensExchange === true) {
        BrightnessDataMu = property.mu
        if (this.selectedLensData.id.indexOf('LX') > -1) {
          BrightnessDataCc = property.cc
        }
      }
      let checkMax = this.houseInfo.roomH - BrightnessDataMu - BrightnessDataCc - (this.isLShaped && this.position === 1 ? this.offset : 0)
      if (ceiling2bottom > checkMax) {
        ceiling2bottom = checkMax
        this.ceiling2bottomProjectorData = this.$commonJs.changeUnit(ceiling2bottom, this.graph.unit, false)
      }
      temoPjz = ceiling2bottom + BrightnessDataMu + BrightnessDataCc + (this.isLShaped && this.position === 1 ? this.offset : 0)
      if (this.isLShaped && this.position === 1) {
        if (this.real_throw_distance_checked) {
          temoPjz = this.graph.pjZ
          this.ceiling2bottomProjectorData = this.$commonJs.changeUnit(temoPjz - this.offset - property.cc - property.mu, this.graph.unit, false)
        } else {
          let { max, min } = this.getPjyRangeNoChangeUnit()
          let disk = this.houseInfo.roomH - temoPjz
          disk = this.$commonJs.checkRange(disk, min, max)
          temoPjz = this.houseInfo.roomH - disk
          this.ceiling2bottomProjectorData = this.$commonJs.changeUnit(temoPjz - this.offset - property.cc - property.mu, this.graph.unit, false)
          this.PJZ(temoPjz)
          if (this.throw_distance_checked) this.changeDistance()
        }
      } else {
        this.PJZ(temoPjz)
      }
    },

    // 壁から壁掛け金具取付部まで
    getWall2WallData () {
      let w2wall = 0
      if (this.$commonViewJs.isLShaped() && (this.position === 3 || this.position === 4)) {
        let f2l = this.houseInfo.roomD - this.graph.pjY < 0 ? 0 : this.houseInfo.roomD - this.graph.pjY
        let property = this.$commonJs.getBrightnessPJProperty()
        w2wall = f2l - property.cc - property.mu - this.offset
      }
      return this.$commonJs.changeUnit(w2wall, this.graph.unit)
    },
    changeWall2WallProjectorChecked () {
      this.SET_WALLWALLPROJECTORCHECKED(this.wall_wallProjector_checked)
    },
    changeWall2WallProjector () {
      if (this.real_throw_distance_checked) {
        this.wall2WallProjectorData = this.getWall2WallData()
        return
      }
      this.isLShaped = this.$commonViewJs.isLShaped()
      if (this.isLShaped && (this.position === 3 || this.position === 4)) {
        let property = this.$commonJs.getBrightnessPJProperty()
        let wall2wall = this.$commonJs.changeUnit(this.wall2WallProjectorData, this.graph.unit, true)
        let temoPjy = this.houseInfo.roomD - wall2wall - property.mu - property.cc - this.offset
        let { max, min } = this.getPjyRangeNoChangeUnit()
        temoPjy = this.$commonJs.checkRange(temoPjy, min, max)
        this.SET_GRAPH_PJY(temoPjy)
        this.wall2WallProjectorData = this.getWall2WallData()
        if (this.throw_distance_checked) this.changeDistance()
      }
    },

    // 床からプロジェクター背面まで
    getFloor2rearProjector () {
      let property = this.$commonJs.getBrightnessPJProperty()
      let f2r = this.houseInfo.roomH - this.graph.pjZ - property.pjwidth
      return this.$commonJs.changeUnit(f2r, this.graph.unit)
    },
    changeFloor2rearProjector () {
      let f2rear = this.$commonJs.changeUnit(this.floor2rearProjectorData, this.graph.unit, true)
      let property = this.$commonJs.getBrightnessPJProperty()
      let temPjz = this.houseInfo.roomH - property.pjwidth - this.limitData
      if (f2rear > temPjz) {
        f2rear = temPjz
        this.floor2rearProjectorData = this.$commonJs.changeUnit(f2rear, this.graph.unit, false)
      }
      temPjz = this.houseInfo.roomH - f2rear - property.pjwidth
      this.PJZ(temPjz)
    },

    // 床からプロジェクター前面まで
    getFloor2frontProjector () {
      let property = this.$commonJs.getBrightnessPJProperty()
      let f2f = this.houseInfo.roomH - this.graph.pjZ - property.lx
      return this.$commonJs.changeUnit(f2f, this.graph.unit)
    },
    changeFloor2frontProjector () {
      let f2front = this.$commonJs.changeUnit(this.floor2frontProjectorData, this.graph.unit, true)
      let property = this.$commonJs.getBrightnessPJProperty()
      let temPjz = this.houseInfo.roomH - property.lx - this.limitData
      if (f2front > temPjz) {
        f2front = temPjz
        this.floor2frontProjectorData = this.$commonJs.changeUnit(f2front, this.graph.unit, false)
      }
      temPjz = this.houseInfo.roomH - f2front - property.lx
      this.PJZ(temPjz)
    },

    ...mapMutations([
      'SCRNW',
      'SCRNH',
      'PJY',
      'SET_UNIT',
      'SET_OTHER_POSITION',
      'SET_GRAPH_ROOMW',
      'SET_GRAPH_ROOMH',
      'SET_GRAPH_ROOMD',
      'SET_GRAPH_PJY',
      'SET_GRAPH_SCRNW',
      'SET_GRAPH_SCRNH',
      'SET_SCREENSIZE',
      'SET_BRIGHTNESS',
      'SET_VANGLE',
      'SET_VANGLEFLAG',
      'SET_HANGLE',
      'SET_HANGLEFLAG',
      'SET_OFFSET',
      'SET_FLOOR2BOTTOM',
      'F_S2D',
      'F_D2S',
      'ASPECTRATIO',
      'PJZ',
      'SET_GAIN',
      'SET_APPLICATION',
      'SELECTRATIODATA',
      'SET_THROWDISTANCECHECKED',
      'SET_SCREENSIZECHECKED',
      'SET_BLACKSIZE',
      'SET_REALTHROWDISTANCECHECKED',
      'SET_CENTERPOSITIONINIT',
      'SET_SCREENPOSITIONCHECKED',
      'SET_FLTOB',
      'SET_FLTOL',
      'PJX',
      'SET_INITSCREENSIZEW',
      'SET_INITSCREENSIZEH',
      'SET_DASHFLAG',
      'VLENSSHIFT',
      'SET_VLENSSHIFT',
      'SET_HLENSSHIFT',
      'SET_PROJECTORCHECKED',
      'SET_POSITION',
      'SET_SCREENMOVECHECKED',
      'SET_TEMVLENSSHIFT',
      'SET_ISUSTWALL',
      'SET_FINGERTOUCHSTATUS',
      'SCREENSIZE',
      'SET_OUTOFSPECVAL',
      'SET_ISOUTOFSPEC',
      'SET_RATIOSCREENSIZEMIN',
      'SET_RATIOSCREENSIZEMAX',
      'SET_FLOORFOOTPROJECTORCHECKED',
      'SET_CEILINGBOTTOMPROJECTORCHECKED',
      'SET_WALLWALLPROJECTORCHECKED'
    ])
  },
  computed: {
    ...mapState([
      'graph',
      'deepmInit',
      'heightmInit',
      'proportion',
      'matchingLensID',
      'selectedModelData',
      'screenSize',
      'brightness',
      'vAngleFlag',
      'vAngle',
      'hAngleFlag',
      'hAngle',
      'offset',
      'floor2bottom',
      'selectedLensData',
      'houseInfo',
      'gain',
      'throwDistanceChecked',
      'realThrowDistanceChecked',
      'selectRatioData',
      'screenSizeChecked',
      'aspectRatio',
      'centerPointData',
      'centerPositionInit',
      'drawData',
      'blackDrawData',
      'flToB',
      'flToL',
      'initScreenSize',
      'vLensShiftNow',
      'hLensShiftNow',
      'screen4Point',
      'limitData',
      'temVLensShift',
      'isUSTWall',
      'fingerTouchStatus',
      'application',
      'language',
      'keyStoneHorizontal',
      'isVAngleOut',
      'outOfSpecVal',
      'isOutOfSpec',
      'ustLensToFrontPj',
      'searchParams',
      'isSimple',
      'floorFootProjectorChecked',
      'ceilingBottomProjectorChecked',
      'wallWallProjectorChecked'
    ]),

    ...mapGetters([
      'unitLabel',
      'selectedLensData_lcd_distInfo'
    ]),

    sliderL () {
      let nowPjy = this.$commonViewJs.getKy() - this.offset
      let persent = (nowPjy - this.throwDisSliderMin) / (this.throwDisSliderMax - this.throwDisSliderMin)
      return persent * 100
    },

    slidertL () {
      let nowPjy = this.$commonViewJs.getLy() - this.offset
      let persent = (nowPjy - this.throwDisSliderMin) / (this.throwDisSliderMax - this.throwDisSliderMin)
      return persent * 100
    },

    throwDisSlidertFormat () {
      return this.$commonJs.changeUnit(this.throwDisSlidert - (this.isUSTWall ? this.ustLensToFrontPj : 0) - this.offset, this.graph.unit)
    },

    throwDisSliderwFormat () {
      return this.$commonJs.changeUnit(this.throwDisSliderw - (this.isUSTWall ? this.ustLensToFrontPj : 0) - this.offset, this.graph.unit)
    },

    throwDisSliderMinFormat () {
      return this.$commonJs.changeUnit(this.throwDisSliderMin - (this.isUSTWall ? this.ustLensToFrontPj : 0), this.graph.unit)
    },

    throwDisSliderMaxFormat () {
      return this.$commonJs.changeUnit(this.throwDisSliderMax - (this.isUSTWall ? this.ustLensToFrontPj : 0), this.graph.unit)
    },

    diagonalMinFormat () {
      if (!this.selectRatioData) {
        return 0
      }
      if (this.dwhSelect === '0') {
        let defaultDistData = this.selectRatioData
        let screenMin = defaultDistData.screenSize.w.min
        return screenMin
      } else {
        return this.$commonJs.changeUnit(this.diagonalMin, this.graph.unit)
      }
    },

    diagonalMaxFormat () {
      if (!this.selectRatioData) {
        return 0
      }
      if (this.dwhSelect === '0') {
        let defaultDistData = this.selectRatioData
        let screenMax = defaultDistData.screenSize.w.max
        return screenMax
      } else {
        return this.$commonJs.changeUnit(this.diagonalMax, this.graph.unit)
      }
    },

    distanceLockedSizetFormat () {
      let dist = this.$commonViewJs.getDistanceFromZorY()
      let distanceLockedSizet = this.$commonViewJs.getScreenByFromDistTele(dist)
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.currentSizet = distanceLockedSizet
      if (this.dwhSelect === '0') {
        return distanceLockedSizet.toFixed(2)
      } else {
        let wh = this.$commonViewJs.getScreenXYByScreenSize(distanceLockedSizet, this.aspectRatio)
        let t
        if (this.dwhSelect === '1') {
          t = wh.calX
        }
        if (this.dwhSelect === '2') {
          t = wh.calY
        }
        return this.$commonJs.changeUnit(t, this.graph.unit, false, true)
      }
    },

    distanceLockedSizewFormat () {
      let dist = this.$commonViewJs.getDistanceFromZorY()
      let distanceLockedSizew = this.$commonViewJs.getScreenByFromDistWide(dist)
      this.$nextTick(() => {
        this.screenSizeWidth(distanceLockedSizew)
      })
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.currentSizew = distanceLockedSizew
      if (this.dwhSelect === '0') {
        return distanceLockedSizew.toFixed(2)
      } else {
        let wh = this.$commonViewJs.getScreenXYByScreenSize(distanceLockedSizew, this.aspectRatio)
        let w
        if (this.dwhSelect === '1') {
          w = wh.calX
        }
        if (this.dwhSelect === '2') {
          w = wh.calY
        }
        return this.$commonJs.changeUnit(w, this.graph.unit, false, true)
      }
    },

    unitData: {
      get () {
        return this.graph.unit
      },

      set (value) {
        this.SET_UNIT(value)
      }
    },

    position: {
      get () {
        return this.selectedModelData.position
      },

      set (value) {
        this.SET_OTHER_POSITION(value)
      }
    },

    brightnessData: {
      get () {
        return this.brightness
      },

      set (value) {
        this.SET_BRIGHTNESS(value)
      }
    },

    vAngleDataComputed () {
      return this.vAngle
    },

    vAngleFlagData: {
      get () {
        return this.vAngleFlag
      },

      set (value) {
        if (this.throwDistanceChecked && value) {
          this.SET_THROWDISTANCECHECKED(false)
          this.SET_DASHFLAG(true)
        } else {
          this.SET_DASHFLAG(false)
        }
        this.SET_VANGLEFLAG(value)
        if (value) {
          this.SET_SCREENMOVECHECKED(false)
        }
      }
    },

    hAngleDataComputed () {
      return this.hAngle
    },

    hAngleFlagData: {
      get () {
        return this.hAngleFlag
      },

      set (value) {
        if (this.throwDistanceChecked && value) {
          this.SET_THROWDISTANCECHECKED(false)
          this.SET_DASHFLAG(true)
        } else {
          this.SET_DASHFLAG(false)
        }
        this.SET_HANGLEFLAG(value)
        if (value) {
          this.SET_SCREENMOVECHECKED(false)
        }
      }
    },

    screenSizeSlider: {
      get () {
        return parseFloat(this.screenSizeData)
      },
      set (value) {
        // let disMax = parseFloat(this.getScreenSizeRange().max)
        this.throwDisWidth()
        // if (value === disMax) {
        //   this.screenSizeData = value
        //   return
        // }
        this.diagonalSliderCurrent = value
        if (this.$refs['screenSizeSliderFlag'].dragging === true) {
          this.screenSizeData = value
          this.changeScreenSize()
          // this.labLeft = this.$refs['screenSizeSliderFlag'].$children[0].$children[0].$refs.popper.offsetLeft
        }
      }
    },

    roomW () {
      return this.houseInfo.roomW
    },

    roomH () {
      return this.houseInfo.roomH
    },

    roomD () {
      return this.houseInfo.roomD
    },

    pjY () {
      return this.graph.pjY
    },

    pjZ () {
      return this.graph.pjZ
    },

    scrnW () {
      return this.graph.scrnW
    },

    scrnH () {
      return this.graph.scrnH
    },

    screenSizeDataComputed: {
      get () {
        return (this.screenSize * 1).toFixed(2)
      }
    },

    offsetComputed () {
      return this.offset
    },

    selectedLensOptions () {
      return this.selectedLensData_lcd_distInfo.map((item) => {
        return {
          key: item.ratio,
          value: item.ratio
        }
      })
    },

    unit () {
      return this.graph.unit
    },

    aspectRatioData: {
      get () {
        return this.aspectRatio
      },

      set (value) {
        this.ASPECTRATIO(value)
      }
    },

    f_d2sComputed () {
      return this.graph.f_d2s
    },

    gainComputed () {
      return this.gain
    },
    floor_footProjector_checked: {
      get () {
        return this.floorFootProjectorChecked
      },
      set (value) {
        this.SET_FLOORFOOTPROJECTORCHECKED(value)
      }
    },
    throw_distance_checked: {
      get () {
        return this.throwDistanceChecked
      },
      set (value) {
        if (this.screenSizeChecked) {
          this.SET_CENTERPOSITIONINIT(this.centerPointData)
        }
        if (this.screen4Point.length === 4 && !this.vAngleFlag && !this.hAngleFlag) {
          this.SET_FLTOB(this.isLShaped01 ? this.screen4Point[3].y : this.houseInfo.roomH - this.screen4Point[3].z)
          this.SET_FLTOL(this.screen4Point[3].x)
        }
        this.SET_THROWDISTANCECHECKED(value)
        if (value) {
          this.SET_DASHFLAG(false)
          this.SET_SCREENMOVECHECKED(false)
          this.SET_VANGLEFLAG(false)
          this.SET_HANGLEFLAG(false)
        }
      }
    },
    screen_size_checked: {
      get () {
        return this.isUSTWall || this.isSimple ? false : this.screenSizeChecked
      },
      set (value) {
        // 勿删，备用
        // this.SET_BLACKSIZE(this.$commonViewJs.calDistanceInitToScreensizeWide(this.graph.pjY))
        this.SET_SCREENSIZECHECKED(value)
        // if (value && this.realThrowDistanceChecked) {
        this.SET_REALTHROWDISTANCECHECKED(false)
        //   this.resetScreenByPjy()
        // }
        // if (!value) {
        let dist = this.$commonViewJs.calScreensizeToDistanceWide(this.screenSize)
        this.$commonViewJs.setZorYByDist(dist)
        this.checkIsElectron()
        this.throwDisWidth()
        // }
        // this.throwDisSliderRangeData = this.graph.pjY - this.$commonViewJs.getKy()
      }
    },

    real_throw_distance_checked: {
      get () {
        return this.realThrowDistanceChecked
      },
      set (value) {
        this.SET_REALTHROWDISTANCECHECKED(value)
        if (value) {
          if (this.screenSizeChecked) {
            this.SET_SCREENSIZECHECKED(false)
            let dist = this.$commonViewJs.calScreensizeToDistanceWide(this.screenSize)
            this.$commonViewJs.setZorYByDist(dist)
            this.checkIsElectron()
            this.throwDisWidth()
          }
          // this.screenSizeWidth()
        } else {
          let dist = this.$commonViewJs.getDistanceFromZorY()
          this.$commonViewJs.setZorYByDist(dist * (1 + this.limitData))
        }
      }
    },
    realThrowDisSliderRangeData: {
      get () {
        let dist = this.$commonViewJs.getDistanceFromZorY()
        let screenSizeTele = this.$commonViewJs.getScreenByFromDistTele(dist)
        if (screenSizeTele < this.ratioScreenSizeMin) screenSizeTele = this.ratioScreenSizeMin
        let re = parseFloat(this.screenSizeData - screenSizeTele)
        return re < 0 ? 0 : re
      },
      set (value) {
        if (this.realThrowDistanceChecked) {
          let dist = this.$commonViewJs.getDistanceFromZorY()
          let screenSizeTele = this.$commonViewJs.getScreenByFromDistTele(dist)
          if (screenSizeTele < this.ratioScreenSizeMin) screenSizeTele = this.ratioScreenSizeMin
          let size = value + screenSizeTele
          this.checkScreenSizeNoPjy(size)
        }
      }
    },

    floor2bottomComputed () {
      return this.floor2bottom
    },

    floor2footProjectorComputed () {
      let BrightnessDataFe = this.getBrightnessFe
      let f2l = this.houseInfo.roomH - this.graph.pjZ < 0 ? 0 : this.houseInfo.roomH - this.graph.pjZ
      let f2foot = f2l - this.selectedLensData.fe
      if (this.selectedModelData.lensExchange === true) {
        if (this.$commonViewJs.isLShaped() && this.position === 0) {
          let property = this.$commonJs.getBrightnessPJProperty()
          f2foot = f2l - this.offset - property.pjheight
        } else {
          f2foot = f2l - BrightnessDataFe
        }
      }
      return this.$commonJs.changeUnit(f2foot, this.graph.unit)
    },

    screenSizeOut () {
      return this.screenSizeData > this.selectedLensData.lcd.screenSize.w.max || this.screenSizeData < this.selectedLensData.lcd.screenSize.w.min
    },

    screen2LensFlag () {
      return this.graph.f_s2d.t.a === 0 && this.graph.f_s2d.t.b === 0 && this.screenSizeChecked
    },
    ustOffsetMax () {
      // ArmLenMax = 0の場合,対象機種Aなので、Wall2ScreenMax = 100mmで終了
      if (this.selectedModelData.ArmLenMax === 0) {
        return this.$commonJs.changeUnit(this.ustOffsetMaxVal, this.graph.unit, false, true)
      } else {
        // 壁掛け金具のオフセット
        let offset
        // 現在の壁掛け金具のアームの長さ
        let CurrentArmLen
        // 現在の投写距離
        let CurrentDist
        // 壁からスクリーンの最大距離＝ボード厚み最大
        let Wall2ScreenMax
        // CurrentScreenSize < ChangeSize,オフセット切り替え基準の投写サイズ未満OffsetにOffsetLessThanChangeSizeの値を代入する.
        // 上記以外の場合,オフセット切り替え基準の投写サイズ以上OffsetにOffsetMoreThanChangeSizeの値を代入する
        // 用cm来计算
        if (this.screenSizeData < this.selectedModelData.ChangeSize) {
          offset = this.$commonJs.changeUnit(this.selectedModelData.OffsetLessThanChangeSize, 'T_MILLIMETER_MM', true)
        } else {
          offset = this.$commonJs.changeUnit(this.selectedModelData.OffsetMoreThanChangeSize, 'T_MILLIMETER_MM', true)
        }
        CurrentDist = this.$commonJs.changeUnit(this.pjYData, this.graph.unit, true)
        CurrentArmLen = CurrentDist + offset
        Wall2ScreenMax = this.$commonJs.changeUnit(this.selectedModelData.ArmLenMax, 'T_MILLIMETER_MM', true) - CurrentArmLen
        return this.$commonJs.changeUnit(Wall2ScreenMax < 0 ? 0 : Wall2ScreenMax, this.graph.unit, false)
      }
    },
    isHAngleOut () {
      return !this.keyStoneHorizontal
    },

    throwDisSliderData: {
      get () {
        let res = this.$commonViewJs.getDistanceFromZorY().toFixed(1) * 1
        if (res > this.throwDisSliderMax) {
          res = this.throwDisSliderMax
        } else if (res < this.throwDisSliderMin) {
          res = this.throwDisSliderMin
        }
        return res
      },
      set (value) {
        let cu = this.getLimitDistance(value)
        let lshapeLock = this.isLShaped &&
        ((this.position === 0 && this.floor_footProjector_checked) ||
         (this.position === 1 && this.ceiling_bottomProjector_checked) ||
         ((this.position === 3 || this.position === 4) && this.wall_wallProjector_checked)
        )
        if (lshapeLock) {
          cu = this.$commonViewJs.getDistanceFromZorY()
        }
        this.throwdisCurrnet = cu
        if (this.$refs['throwDisSliderFlag'].dragging === true) {
          this.$commonViewJs.setZorYByDist(cu)
          this.changeSliderDistance()
        }
      }
    },
    throwDisSli () {
      let m = this.throwDisSliderMax - (this.isUSTWall ? this.ustLensToFrontPj : 0)
      if (this.throwDisSlidert - this.offset > m) {
        return m - (this.throwDisSliderw - this.offset)
      }
      return this.throwDisSlidert - this.throwDisSliderw
    },
    throwDisSliderRangeData: {
      get () {
        let dist = this.$commonViewJs.getDistanceFromZorY()
        // console.log('throwDisSliderRangeData dist', dist)
        let res = dist + this.offset - this.throwDisSliderw
        return res < this.limitData ? 0 : (res > this.throwDisSli ? this.throwDisSli : res)
      },
      set (value) {
        // let cu = this.getLimitDistance(this.$commonViewJs.getKy() + value)
        let cu = this.$commonViewJs.getKy() + value - this.offset
        this.throwDisChangedSizeLockedCurrent = cu
        if (this.$refs['throwDisSliderRangeFlag'].dragging === true) {
          this.$commonViewJs.setZorYByDist(cu)
        }
      }
    },
    outOfSpec: {
      get () {
        return this.outOfSpecVal
      },
      set (value) {
        this.SET_OUTOFSPECVAL(value)
        this.SET_ISOUTOFSPEC(value)
        if (!value) {
          let dist = this.$commonViewJs.getDistanceFromZorY()
          let result = this.$commonViewJs.getScreenByFromDistWide(dist)
          this.checkScreenSize(result)
        }
      }
    },
    getBrightnessFe () {
      let brightnessfe
      let lensExchange = this.selectedModelData.lensExchange
      if (lensExchange) {
        let code = this.selectedModelData.code
        let lensId = this.selectedLensData.id
        for (let i = 0; i < this.Brightness.optionLens.length; i++) {
          if (this.Brightness.optionLens[i].code === code && this.Brightness.optionLens[i].lensId === lensId) {
            brightnessfe = this.Brightness.optionLens[i].fe / 10
          }
        }
      }
      return brightnessfe
    }
  },

  watch: {
    selectRatioData (newValue, oldValue) {
      this.ratioScreenSizeMin = newValue.screenSize.w.min
      this.ratioScreenSizeMax = newValue.screenSize.w.max
    },
    real_throw_distance_checked (newValue, oldValue) {
      if (newValue) {
        this.screenSizeWidth()
      }
    },
    roomW (newValue, oldValue) {
      this.roomWData = this.$commonJs.changeUnit(newValue, this.graph.unit, false, true)
    },

    roomH (newValue, oldValue) {
      this.roomHData = this.$commonJs.changeUnit(newValue, this.graph.unit, false, true)
    },

    roomD (newValue, oldValue) {
      this.roomDData = this.$commonJs.changeUnit(newValue, this.graph.unit, false, true)
    },

    pjY (newValue, oldValue) {
      if (this.isLShaped01) return
      let value = this.isUSTWall ? newValue - this.ustLensToFrontPj : newValue
      this.pjYData = this.$commonJs.changeUnit(value, this.graph.unit)
      this.throwDisSliderw = this.$commonViewJs.getKy()
      this.throwDisSlidert = this.$commonViewJs.getLy()
      if (!this.screen_size_checked) {
        // 获取黑边的长宽
        this.resetScreenByPjy()
      }
    },

    pjZ (newValue, oldValue) {
      if (!this.isLShaped01) return
      let value = this.position === 1 ? this.houseInfo.roomH - newValue : newValue
      this.pjYData = this.$commonJs.changeUnit(value, this.graph.unit)
      this.throwDisSliderw = this.$commonViewJs.getKy()
      this.throwDisSlidert = this.$commonViewJs.getLy()
      if (!this.screen_size_checked) {
        // 获取黑边的长宽
        this.resetScreenByPjy()
      }
    },

    scrnW (newValue, oldValue) {
      this.scrnWData = this.$commonJs.changeUnit(newValue, this.graph.unit)
    },

    scrnH (newValue, oldValue) {
      this.scrnHData = this.$commonJs.changeUnit(newValue, this.graph.unit)
    },

    offsetComputed (newValue, oldValue) {
      this.offsetData = this.$commonJs.changeUnit(newValue, this.graph.unit)
    },

    screenSizeDataComputed (newValue, oldValue) {
      this.screenSizeData = newValue
    },

    unit (newValue, oldValue) {
      this.roomWData = this.$commonJs.changeUnit(this.roomW, newValue, false, true)
      this.roomHData = this.$commonJs.changeUnit(this.roomH, newValue, false, true)
      this.roomDData = this.$commonJs.changeUnit(this.roomD, newValue, false, true)

      let dist = this.$commonViewJs.getDistanceFromZorY()
      let value = this.isUSTWall ? dist - this.ustLensToFrontPj : dist
      this.pjYData = this.$commonJs.changeUnit(value, newValue)

      this.scrnWData = this.$commonJs.changeUnit(this.scrnW, newValue)
      this.scrnHData = this.$commonJs.changeUnit(this.scrnH, newValue)
      this.offsetData = this.$commonJs.changeUnit(this.offsetComputed, newValue)
      this.floor2bottomData = this.$commonJs.changeUnit(this.floor2bottomComputed, newValue)
      this.floor2footProjectorData = this.$commonJs.changeUnit(this.floor2footProjectorData, newValue)
      this.leftWall2topData = this.$commonJs.changeUnit(this.leftWall2topData, newValue)
      this.ceiling2bottomProjectorData = this.$commonJs.changeUnit(this.ceiling2bottomProjectorData, newValue)
      this.wall2WallProjectorData = this.$commonJs.changeUnit(this.wall2WallProjectorData, newValue)
      this.floor2rearProjectorData = this.$commonJs.changeUnit(this.floor2rearProjectorData, newValue)
      this.floor2frontProjectorData = this.$commonJs.changeUnit(this.floor2frontProjectorData, newValue)
    },

    f_d2sComputed (newValue, oldValue) {
      if (this.screenSizeChecked) {
        this.changeDistanceOnSizeLocked()
      } else if (this.throwDistanceChecked) {
        this.changeDistanceOnThrowDisLocked()
      } else {
        this.changeDistance()
      }
      this.SELECTRATIODATA(this.$commonJs.findSpecInfoByRatio(this.aspectRatio, this.selectedLensData))
      this.changeDiagonal()
      this.changeDwhSelect()
    },

    gainComputed (newValue, oldValue) {
      this.gainData = newValue
    },

    vAngleDataComputed (newValue, oldValue) {
      this.vAngleData = newValue
    },

    hAngleDataComputed (newValue, oldValue) {
      this.hAngleData = newValue
    },

    drawData (newValue, oldValue) {
      if (newValue) {
        let data = newValue[0].reduce((data1, data2) => {
          return data1.z > data2.z ? data1 : data2
        })
        this.SET_FLOOR2BOTTOM(this.roomH - data.z)
        this.floor2bottomData = this.$commonJs.changeUnit(this.roomH - data.z, this.unit)
        this.floor2footProjectorData = this.floor2footProjectorComputed
        this.ceiling2bottomProjectorData = this.getCeiling2topData()
        this.leftWall2topData = this.getLeftWall2topData()
        this.wall2WallProjectorData = this.getWall2WallData()
        this.floor2rearProjectorData = this.getFloor2rearProjector()
        this.floor2frontProjectorData = this.getFloor2frontProjector()
        this.changeDiagonal()
      }
    },

    selectedModelData (newValue, oldValue) {
      this.position = newValue.position
    },
    isUSTWall (val) {
      if (val) {
        this.SELECTRATIODATA(this.$commonJs.findSpecInfoByRatio(this.aspectRatio, this.selectedLensData))
        if (this.offset > this.ustOffsetMaxVal) {
          this.SET_OFFSET(this.ustOffsetMaxVal)
        } else if (this.roomH > 500) {
          this.SET_GRAPH_ROOMH(500)
        } else if (this.roomH < 200) {
          this.SET_GRAPH_ROOMH(200)
        }
      }
      if (this.isLShaped01) this.changeScreenSize()
      let dist = this.$commonViewJs.getDistanceFromZorY()
      let value = val ? dist - this.ustLensToFrontPj : dist
      this.pjYData = this.$commonJs.changeUnit(value, this.graph.unit)
    },
    // 监听ボードの厚み最大值 超过最大值 ボードの厚みthis.offsetData=ustOffsetMax
    ustOffsetMax (newValue, oldValue) {
      if (this.offsetData > newValue) {
        this.offsetData = newValue
        this.SET_OFFSET(this.$commonJs.changeUnit(newValue, this.graph.unit, true))
      }
    }
  },

  components: {
    dropdown,
    Header
  }
}
</script>

<style scoped>
  .van-col--8 {
    padding-left: 7.5px !important;
    padding-right: 7.5px !important;
  }

  .panel-box {
    padding: 15px 18px 18px 18px;
    background: #fff;
    margin-bottom: 10px;
    font-size: 14px;
    border-bottom: 0.5px solid #ccc;
    border-top: 0.5px solid #ccc;
  }

  .simple_condition .panel-box {
    margin-bottom: 0px;
    border-bottom: none;
    border-top: none;
  }

  .projector-condition1 .panel-box {
    border-top: 0
  }

  .projector-condition1 .van-row {
    margin-left: 0px !important;
    margin-right: 0px !important;
  }

  .panel-box-title-big {
    font-size: 15px;
    line-height: 15px;
    font-weight: bold;
    color: #000;
    padding: 0;
    margin-bottom: 15px
  }
  .panel-box-title-big2 {
    font-size: 14px;
    line-height: 15px;
    color: #000;
    padding: 0;
    margin-bottom: 15px;
    margin-top: 3px;
  }
  .panel-box-title-width{
    width: 85%;
  }

  .panel-box-title {
    color: #333;
    font-size: 14px;
    line-height: 14px;
    margin: 10px 0
  }

  .dropdown-select-box .dropdown-title {
    margin-bottom: 0
  }

  .mt0 {
    margin-top: 0
  }

  .size .van-cell {
    padding: 0 5px
  }

  .van-row .van-col:last-child {
    padding-right: 0 !important
  }

  .van-row .van-col:first-child {
    padding-left: 0 !important
  }

  .col7 .toggle-box-item {
    border: 0;
    background: #f6f5f8;
  }

  .col7 .toggle-box-item.disable {
    color: #fff;
    background: #f0f0f0;
  }

  .col7 .checked-box-item {
    color: #fff;
    background: #003298;
    border: 0;
  }

  .screen-top {
    display: flex
  }

  .screen-check {
    width: 76px;
    display: flex
  }

  .mt4 {
    margin-top: 4px
  }

  .panel-check .panel-box-title-big {
    float: left;
  }
  .panel-check .panel-box-title-big2 {
    float: left;
  }
  .panel-check .van-checkbox {
    float: right
  }

  .dropdown-select-box .dropdown-select .van-field {
    padding: 1px 4px 1px 8px !important
  }

  .screen-position {
    padding-bottom: 6px
  }

  .throw-distance {
    padding-bottom: 9px
  }

  .throw-distance .panel-box-title-big {
    margin-bottom: 16px
  }

  .advanced-settings {
    margin-bottom: 0;
    padding-bottom: 12px;
    border-bottom: 0
  }

  .advanced-settings .van-col--3 {
    width: auto
  }

  .van-collapse-item__content {
    background-color: #dadada;
    color: #333
  }

  .out-mode .panel-box-title-big {
    margin-bottom: 13px
  }

  .out-mode .van-col--5 {
    width: auto
  }

  .switch-label {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  .switch-title {
    line-height: 33px;
  }

  .van-icon-lock {
    float: right;

  }

  .red {
    border: 1px solid #F56C6C;
  }

  .sld {
    padding: 8px 0px 15px 0px;
  }

  .lab {
    position: relative;
    top: 20px;
  }

  .custom-button {
    width: 16px;
    height: 13px;
    position: relative;
    background-color: #10218b;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  .custom-button::before {
    content: "";
    width: 0px;
    height: 0px;
    color: white;
    text-align: center;
    border-top: 5px solid #10218b;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    position: absolute;
    top: 13px;
    left: 0;
  }

  .condition_sliderbar {
    position: relative;
    height: 50px;
  }

  .border {
    position: relative;
    top: 15px;
    border: 1px solid #999
  }

  .pjy-slider {
    position: relative;
    z-index: 999;
  }

  .screen_size_sld,
  .throw_dis_sld {
    line-height: 10px;
  }

  .check {
    position: absolute;
    width: 100%;
    top: 2px;
  }
  .out_of_spec_dialog {
    padding: 15px
  }
  .out_of_spec_dialog img{
    margin: 0 auto;
    display: block;
    margin-bottom: 10px;
  }
  .out_of_spec_dialog p{
    font-size: 12px
  }
  .out_of_spec_warning{
    padding: 5px 0;
  }
  .out_of_spec_warning img{
    vertical-align: middle
  }
  .out_of_spec_warning span{
    vertical-align: middle;
    color: red
  }
  .screen_size_out_of_spec{
    background: #f7baf7
  }
  .margin_bottom {
    margin-bottom: 15px;
  }
  .screen-size_sliderbar {
    position: relative;
  }
</style>
